import {Link, useLocation, useNavigate} from 'react-router-dom';
import {Suspense, useEffect, useState} from "react";
import {toast, ToastContainer} from "react-toastify";
import Header from "../Header.jsx";
import Button from "../component-assets/Button.jsx";
import ApiRequester from "../ApiRequester.jsx";
import {
    actionAppearance, arraysEqual, callActionModal,
    checkAll, confirmModalHandler,
    convertIsoToLocal,
    formatPhone,
    formCheck,
    formFail,
    formSuccess,
    getAccessSettings,
    getCountryData,
    getStatesByCountry,
    getZipRegexByCountry,
    handleSubmitActions, iAmHigherAuthority, isBannerPresent,
    paginateData,
    reloadSessionCorp, reloadSessionCampusItems, setRoleInfo, showModal,
    sortFunc,
    toggleCollapse, swapModal
} from "../../libs.jsx";
import MaterialIcon from "../component-assets/MaterialIcon.jsx";
import TableBody from "../component-assets/TableBody.jsx";
import TableHeaders from "../component-assets/TableHeaders.jsx";
import {Pagination} from "react-bootstrap";
import PaginationItems from "../component-assets/PaginationItems.jsx";
import Papa from 'papaparse'
import ConfirmModal from "../component-assets/ConfirmModal.jsx";
import {CSVLink} from "react-csv";
import {Modal} from "bootstrap";
import BulkDeleteModal from "../component-assets/BulkDeleteModal.jsx";
import GeofenceTool from "../component-assets/GeofenceTool.jsx";
import {MapContainer, Polygon, Tooltip, LayersControl, LayerGroup} from "react-leaflet";
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';
import Navigation from "../Navigation.jsx";
import imgMap from '../component-assets/ImageMap.jsx';
import { getSession } from "../../services/session";

const CampusProfile = (props) => {
    let dData, bData, countryOptions = [], userHeaderData, groupHeaderData, afrHeaderData, hpHeaderData, noteHeaderData,
        reasonHeaderData, noteCSVHeaderData;

    const useLocationData = useLocation();
    const navigate = useNavigate();

    dData = getSession();

    userHeaderData = [
        {label: "Username", key: "UserName", align: "left"},
        {label: "Display Name", key: "DisplayName", align: "left"},
        {label: "Email", key: "Email", align: "left"},
        {label: "Role", key: "UserRole", align: "left"}
    ];

    groupHeaderData = [
        {label: "Group Name", key: "GroupName", align: "left"},
        {label: "CapCode", key: "CapCode", align: "left"}
    ];

    afrHeaderData = [
        {label: "Device Name", key: "device_type_name", align: "left"},
    ];

    hpHeaderData = [
        {label: "Event Type", key: "event_type_name", align: "left"},
    ];

    reasonHeaderData = [
        {label: "Reason", key: "reason_code_description", align: "center"}
    ];

    noteHeaderData = [
        {label: "Timestamp", key: "last_modified", align: "center", type: "datetime-utc"},
        {label: "Created By", key: "display_name", align: "center"},
        {label: "Note", key: "note", align: "left"},
    ];

    noteCSVHeaderData = [
        {label: "Note ID", key: "note_id"},
        {label: "Timestamp", key: "last_modified"},
        {label: "Created By", key: "display_name"},
        {label: "Note", key: "note"},
        {label: "Created On", key: "create_time"}
    ];

    // Permission Variables
    const [addRights, setAddRights] = useState(iAmHigherAuthority(80, dData.my_role_weight));
    const [editRights, setEditRights] = useState(iAmHigherAuthority(80, dData.my_role_weight));
    const [read, setRead] = useState(true);
    // Main Page Variables
    const [campusId, setCampusId] = useState(parseInt(props?.id));
    const [count, setCount] = useState(0);
    const [count2, setCount2] = useState(0);
    const [stateData, setStateData] = useState(useLocationData.state);
    const [corpData, setCorpData] = useState([]);
    const [deviceData, setDeviceData] = useState([]);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [timezoneData, setTimezoneData] = useState([]);
    const [tabItem, setTabItem] = useState("init");
    const [corporateOptions, setCorporateOptions] = useState([]);
    const [geofenceMap, setGeofenceMap] = useState(<></>);
    const [zoneTypeData, setZoneTypeData] = useState([]);
    const [zoneTypeLoaded, setZoneTypeLoaded] = useState(false);
    const [outputOp, setOutputOp] = useState("Add");
    // Basic Information Variables
    const [basicData, setBasicData] = useState([]);
    const [campusName, setCampusName] = useState("");
    const [corporateId, setCorporateId] = useState("");
    const [corporateName, setCorporateName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [zipcode, setZip] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [country, setCountry] = useState("US");
    const [streetAddr, setStreetAddr] = useState("");
    const [timezone, setTimezone] = useState("");
    const [timezoneId, setTimezoneId] = useState(0);
    const [servicePlan, setServicePlan] = useState("");
    const [campusGuid, setCampusGuid] = useState("");
    const [basicLoaded, setBasicLoaded] = useState(false);
    const [roleData, setRoleData] = useState([]);
    const [roleOptions, setRoleOptions] = useState([]);
    const [clickedLatLng, setClickedLatLng] = useState(undefined);
    // Campus Settings
    const [settingLoaded, setSettingsLoaded] = useState(false);
    // Campus Event Reporting Settings
    const [isEventNotes, setIsEventNotes] = useState(false);
    const [isNotesFreeform, setIsNotesFreeform] = useState(false);
    const [isNotesPreform, setIsNotesPreform] = useState(false);
    const [isReasonEditable, setIsReasonEditable] = useState(false);
    const [isResidentTrends, setIsResidentTrends] = useState(false);
    const [rSettingsOriginList, setRSettingsOriginList] = useState([]);
    const [rSettingList, setRSettingsList] = useState([]);
    // Campus Architecture Settings
    const [isCloud, setIsCloud] = useState(false);
    const [isHybrid, setIsHybrid] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showLegacy, setShowLegacy] = useState(false);
    const [pSettingsOriginList, setPSettingsOriginList] = useState([]);
    const [pSettingList, setPSettingsList] = useState([]);
    // Campus Output Feature Settings
    const [isMobile, setIsMobile] = useState(false);
    const [isPager, setIsPager] = useState(false);
    const [isText, setIsText] = useState(false);
    const [isVoice, setIsVoice] = useState(false);
    const [isLightController, setIsLightController] = useState(false);
    const [isEmail, setIsEmail] = useState(false);
    const [isOffsite, setIsOffsite] = useState(false);
    const [oSettingsList, setOSettingsList] = useState([]);
    const [oSettingsOriginList, setOSettingsOriginList] = useState([]);
    // Campus Notes
    const [noteData, setNoteData] = useState([]);
    const [noteTableRows, setNoteTableRows] = useState([]);
    const [noteLoaded, setNoteLoaded] = useState(false);
    const [noteIdList, setNoteIdList] = useState([]);
    const [notesStoredIndex, setNotesStoredIndex] = useState(0);
    const [notesPage, setNotesPage] = useState(1);
    const [notesPerPage, setNotesPerPage] = useState(100);
    const [noteDContent, setNoteDContent] = useState("");
    const [notesPPRules, setNotesPPRules] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });
    const [noteSorter, setNoteSorter] = useState({
        sortColumn: "create_time",
        sortOrder: "desc"
    });
    const [noteCSVLink, setNoteCSVLink] = useState({
        filename: `campus_notes.csv`,
        headers: [],
        data: []
    });
    const [noteCSVButton, setNoteCSVButton] = useState(
        <CSVLink {...noteCSVLink} uFEFF={false}>
            <Button text={"Export"} icon={true} iconClass={"fe fe-download me-2"}
                    class={"btn btn-primary ms-2 px-4 mt-1"}/>
        </CSVLink>);
    // Upload Variables
    const [timezoneOptions, setTimezoneOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [zipReg, setZipReg] = useState(getZipRegexByCountry("US"));
    const [newFile, setNewFile] = useState("");
    const [newFileExt, setNewFileExt] = useState("");
    const [newFileName, setNewFileName] = useState("");
    const [newFileData, setNewFileData] = useState("");
    const [fileValid, setFileValid] = useState(true);
    const [uploadKey, setUploadKey] = useState("");
    const [uploadTimer, setUploadTimer] = useState(-1);
    const [stgPresent, setStgPresent] = useState(false);
    const [addDevices, setAddDevices] = useState(true);
    const [addAreas, setAddAreas] = useState(true);
    const [addResidents, setAddResidents] = useState(true);
    // User 2.0 Table To Migrate Card Variables
    const [userData, setUserData] = useState([]);
    const [userLoaded, setUserLoaded] = useState(false);
    const [userActiveData, setUserActiveData] = useState([]);
    const [myUserLoaded, setMyUserLoaded] = useState(false);
    const [myUserData, setMyUserData] = useState([]);
    const [userRows, setUserRows] = useState([]);
    const [userIdList, setUserIdList] = useState([]);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(dData.perPage);
    const [dContent, setDContent] = useState("");
    const [sorter, setSorter] = useState({
        sortColumn: "UserName",
        sortOrder: "asc"
    });
    const [ppRules, setPRules] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });
    // Group 2.0 Table to Migrate Card Variables
    const [groupData, setGroupData] = useState([]);
    const [groupLoaded, setGroupLoaded] = useState(false);
    const [groupActiveData, setGroupActiveData] = useState([]);
    const [myGroupData, setMyGroupData] = useState([]);
    const [myGroupLoaded, setMyGroupLoaded] = useState(false);
    const [groupRows, setGroupRows] = useState([]);
    const [groupIdList, setGroupIdList] = useState([]);
    const [groupSearch, setGroupSearch] = useState("");
    const [groupPage, setGroupPage] = useState(1);
    const [dContent2, setDContent2] = useState("");
    const [groupSorter, setGroupSorter] = useState({
        sortColumn: "config_name",
        sortOrder: "asc"
    });
    const [groupPPRules, setGroupPRules] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });
    // AFR Settings
    const [afrData, setAFRData] = useState([]);
    const [devTypeData, setDevTypeData] = useState([]);
    const [devTypeLoaded, setDevTypeLoaded] = useState([]);
    const [myAFRData, setMyAFRData] = useState([]);
    const [afrLoaded, setAFRLoaded] = useState(false);
    const [myAFRLoaded, setMyAFRLoaded] = useState(false);
    const [afrDataSet, setAFRDataSet] = useState([]);
    const [afrRows, setAFRRows] = useState([]);
    const [afrIdList, setAFRIdList] = useState([]);
    const [afrOriginIdList, setAFROriginIdList] = useState([]);
    const [dContent3, setDContent3] = useState("");
    const [afrSorter, setAFRSorter] = useState({
        sortColumn: "device_type_name",
        sortOrder: "asc"
    });
    // High Priority Settings
    const [hpData, setHPData] = useState([]);
    const [myHPData, setMyHPData] = useState([]);
    const [hpLoaded, setHPLoaded] = useState(false);
    const [myHPLoaded, setMyHPLoaded] = useState(false);
    const [eventTypeData, setEventTypeData] = useState([]);
    const [eventTypeLoaded, setEventTypeLoaded] = useState(false);
    const [hpDataSet, setHPDataSet] = useState([]);
    const [hpRows, setHPRows] = useState([]);
    const [hpIdList, setHPIdList] = useState([]);
    const [hpOriginIdList, setHPOriginIdList] = useState([]);
    const [dContent4, setDContent4] = useState("");
    const [hpSorter, setHPSorter] = useState({
        sortColumn: "event_type_name",
        sortOrder: "asc"
    });
    // Alert Settings
    const [alertData, setAlertData] = useState([]);
    const [myAlertData, setMyAlertData] = useState([]);
    const [myAlertDataLoaded, setMyAlertDataLoaded] = useState(false);
    const [alertLoaded, setAlertLoaded] = useState(false);
    // Reason Code Settings
    const [reasonData, setReasonData] = useState([]);
    const [reasonLoaded, setReasonLoaded] = useState(false);
    const [myReasonData, setMyReasonData] = useState([]);
    const [myReasonLoaded, setMyReasonLoaded] = useState(false);
    const [reasonIdList, setReasonIdList] = useState([]);
    const [reasonOriginIdList, setReasonOriginIdList] = useState(false);
    const [reasonDataSet, setReasonDataSet] = useState([]);
    const [reasonRows, setReasonRows] = useState([]);
    const [dContent5, setDContent5] = useState("");
    const [reasonSorter, setReasonSorter] = useState({
        sortColumn: "reason_code_description",
        sortOrder: "asc"
    });
    // Geofence Variables
    const [geoData, setGeoData] = useState([]);
    const [geoData2, setGeoData2] = useState([]);
    const [geoLoaded, setGeoLoaded] = useState(true);
    const [mapCont, setMapCont] = useState(<></>);
    const [markers, setMarkers] = useState([]);
    // Integration Variables
    const [vendorData, setVendorData] = useState([]);
    const [vendorLoaded, setVendorLoaded] = useState(false);
    const [iData, setIData] = useState([]);
    const [iLoaded, setILoaded] = useState(false);
    const [yesIntegrations, setYesIntegrations] = useState([]);
    const [noIntegrations, setNoIntegrations] = useState([]);
    const [yIntIndex, setYIntIndex] = useState(0);
    const [nIntIndex, setNIntIndex] = useState(0);
    const [onboardIndex, setOnboardIndex] = useState(0);
    const [onboardSignCheck, setOnboardSignCheck] = useState(false);
    const [onboardFileId, setOnboardFileId] = useState("");
    const [onboardUploadFileId, setOnboardUploadFileId] = useState("");
    const [onboardUploadCheck, setOnboardUploadCheck] = useState("");
    const [uploadCheckCount, setUploadCheckCount] = useState(0);
    const [onboardSignUrl, setOnboardSignUrl] = useState("");
    const [newOnboardFileName, setNewOnboardFileName] = useState("");
    const [onboardFile, setOnboardFile] = useState(null);
    const [newOnboardUploadFileName, setNewOnboardUploadFileName] = useState("");
    const [onboardUploadFile, setOnboardUploadFile] = useState(null);
    const [signCheckCount, setSignCheckCount] = useState(0);
    const [revealedCredentials, setRevealedCredentials] = useState(new Set());
    const [revealedAuthTokens, setRevealedAuthTokens] = useState(new Set());
    // Careflow Settings
    const [careflowV2, setCareflowV2] = useState(false);
    const [areaCareflow, setAreaCareflow] = useState(false);
    const [resCareflow, setResCareflow] = useState(false);
    const [devCareflow, setDevCareflow] = useState(false);
    const [eventCareflow, setEventCareflow] = useState(false);
    const [checkin, setCheckin] = useState(false);
    const [rounds, setRounds] = useState(false);
    const [cSettingsOriginList, setCSettingsOriginList] = useState([]);
    const [cSettingsList, setCSettingsList] = useState([]);

    const countries = getCountryData();
    for (let i2=0; i2 < countries?.length; i2++){
        countryOptions.push(
            <option key={"country-option-"+i2} value={countries[i2][0]}>{countries[i2][1]}</option>
        );
    }

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setCount(count => count - 1);
        }, 1000);
        if (count <= 0){
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId,
                                payload: {campus_filter: campusId.toString()}, "read-only": read,
                                procedure: "getcampuses", reqType: "stored"}).then(data => {
                setBasicData(data ? data : []);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId, Tbl: "core_corporate",
                                procedure: "fetchall", reqType: "direct", "read-only": true}).then(data => {
                setCorpData(data ? data : []);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId, Tbl: "att_timezones",
                                procedure: "fetchall", reqType: "direct", "read-only": true}).then(data => {
                setTimezoneData(data ? data : []);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId,
                                procedure: "getserverstatus", reqType: "stored", "read-only": true}).then(data => {
                setDeviceData(data ? data : []);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId, Tbl: "att_user_roles",
                                procedure: "fetchall", reqType: "direct", "read-only": true}).then(data => {
                setRoleData(data);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId, Tbl: "att_event_types",
                                procedure: "fetchall", reqType: "direct", "read-only": true}).then(data => {
                setEventTypeData(data);
                setEventTypeLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId, Tbl: "att_inovonics_types",
                                procedure: "fetchall", reqType: "direct", "read-only": true}).then(data => {
                setDevTypeData(data);
                setDevTypeLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId,
                                payload: {campus_id: campusId}, "read-only": read,
                                procedure: "getcampusnotes", reqType: "stored"}).then(data => {
                setNoteData(data ? data : []);
                setNoteLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId,
                                payload: {campus_id: campusId}, "read-only": read,
                                procedure: "getgeofence2", reqType: "stored"}).then(data => {
                setGeoData(data?.geo1 ? data.geo1 : {});
                setGeoData2(data?.geo2 ? data.geo2 : []);
                setGeoLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId, Tbl: "att_zone_types",
                                procedure: "fetchall", reqType: "direct", "read-only": true}).then(data => {
                setZoneTypeData(data);
                setZoneTypeLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId, Tbl: "core_campus_alert_settings",
                                procedure: "fetchbyparameter", reqType: "direct", "read-only": read}).then(data => {
                setMyAlertData(data);
                setMyAlertDataLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId, Tbl: "core_afr_entity",
                                procedure: "fetchbyparameter", reqType: "direct", "read-only": read}).then(data => {
                setMyAFRData(data ? data : []);
                setMyAFRLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId, Tbl: "core_user",
                                procedure: "fetchbyparameter", reqType: "direct", "read-only": read}).then(data => {
                setMyUserData(data ? data : []);
                setMyUserLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId, Tbl: "core_reason_codes",
                                procedure: "fetchbyparameter", reqType: "direct", "read-only": read}).then(data => {
                setMyReasonData(data ? data : []);
                setMyReasonLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId, Tbl: "core_high_priority_entity",
                                procedure: "gethighprioritytypes", reqType: "stored", "read-only": read}).then(data => {
                setMyHPData(data ? data : []);
                setMyHPLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId,
                                procedure: "sp_dev_getgroupsbycampusid", reqType: "stored", "read-only": read}).then(data => {
                setMyGroupData(data ? data : []);
                setMyGroupLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId,
                                procedure: "getvendorintegrations", reqType: "stored", "read-only": read}).then(data => {
                setIData(data ? data : []);
                setILoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId,
                                procedure: "getcampusvendors", reqType: "stored", "read-only": read}).then(data => {
                setVendorData(data ? data : []);
                setVendorLoaded(true);
            });
            setRead(true);
            setCount(() => 600);
        }
        return () => clearInterval(interval);
    }, [count]);

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setUploadTimer(count => count - 1);
        }, 1000);
        if (uploadTimer > 0 && uploadTimer%5 === 0 && uploadKey !== ""){
            ApiRequester({reqEndpoint: "myfetch", pKey: "unique_key", pVal: uploadKey, Tbl: "stg_upload_keys",
                                procedure: "fetchbyparameter", reqType: "direct", "read-only": false}).then(data => {
                if (data && data.length > 0){
                    if (data[0]?.upload_complete === 1){
                        setUploadTimer(-1);
                        handleSubmitActions("loadUploadSubmit", "uploadSubmit");
                        document.getElementById("uploadCancel").click();
                        navigate(`/profiles/campus/${campusId}/${uploadKey}`,
                            {state: {message: {success: "Upload data staged for preview.", error: ""}}});
                    }else if (data[0]?.upload_error === 1){
                        setUploadTimer(-1);
                        handleSubmitActions("loadUploadSubmit", "uploadSubmit");
                        toast.error("Error encountered, run the file pre-check, if ok please notify software support.");
                    }
                }else{
                    console.log(data);
                }
            });
        }
        if (uploadTimer === 0 && stgPresent === false){
            handleSubmitActions("loadUploadSubmit", "uploadSubmit");
            toast.error("Timed out performing upload, please try again.");
        }
        return () => clearInterval(interval);
    }, [uploadTimer]);

    useEffect(() => {
        if (![vendorLoaded, iLoaded].includes(false)){
            let ctrl = [], yTmp = [], nTmp = [];
            for (let i=0; i < vendorData.length; i++){
                for (let i2=0; i2 < iData.length; i2++){
                    if (vendorData[i].vendor_id === iData[i2].vendor_id){
                        ctrl.push(vendorData[i].vendor_id);
                        yTmp.push(vendorData[i]);
                    }
                }
            }
            for (let i3=0; i3 < iData.length; i3++){
                if (!ctrl.includes(iData[i3].vendor_id)){
                    nTmp.push(iData[i3]);
                }
            }
            setYesIntegrations(yTmp);
            setNoIntegrations(nTmp);
        }
    }, [vendorData, iData, vendorLoaded, iLoaded])

    useEffect(() => {
        if (stateData && stateData?.message){
            if (stateData.message?.error){
                toast.error(stateData.message.error);
            }else if (stateData.message?.success){
                toast.success(stateData.message.success);
            }
        }
    }, [stateData]);

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setCount2(count => count - 1);
        }, 1000);
        if (count2 <= 0 && campusGuid){
            ApiRequester({reqEndpoint: "getitems", Table: "User", PKey: "CampusId", PVal: campusGuid,
                        SecondIndex: "CampusId-index", CampusId: campusId,
                        Projection: "UserId,DisplayName,Email,UserName,UserRole,GroupIds"}).then(data => {
                setUserData(data);
                setUserLoaded(true);
            });
            ApiRequester({reqEndpoint: "getitems", Table: "Group", PKey: "CampusId", PVal: campusGuid,
                        SecondIndex: "CampusId-index", CampusId: campusId,
                        Projection: "GroupId,CapCode,GroupName"}).then(data => {
                setGroupData(data);
                setGroupLoaded(true);
            });
            ApiRequester({reqEndpoint: "getitems", Table: "CampusConfig", PKey: "CampusId", PVal: campusGuid,
                        CampusId: campusId, Projection: "AFRDevices"}).then(data => {
                setAFRData(data);
                setAFRLoaded(true);
            });
            ApiRequester({reqEndpoint: "getitems", Table: "CampusConfig", PKey: "CampusId", PVal: campusGuid,
                        CampusId: campusId, Projection: "HighPriorityAlertTypes"}).then(data => {
                setHPData(data);
                setHPLoaded(true);
            });
            ApiRequester({reqEndpoint: "getitems", Table: "CampusConfig", PKey: "CampusId", PVal: campusGuid,
                        CampusId: campusId, Projection: "FinishButtonEnabled,FinishTimeInterval,ReleaseTimeInterval," +
                    "AcceptButtonEnabled,ReasonCodeEnabled,CaregiverChgGroupEnabled,UserEditDisplayName,ClearTimeInterval"}).then(data => {
                setAlertData(data);
                setAlertLoaded(true);
            });
            ApiRequester({reqEndpoint: "getitems", Table: "CampusReasonCode", PKey: "CampusId", PVal: campusGuid,
                        CampusId: campusId, Projection: "ReasonCodeId,Description,GlobalReasonCode"}).then(data => {
                setReasonData(data);
                setReasonLoaded(true);
            });
            setCount2(() => 600);
        }
        return () => clearInterval(interval);
    }, [count2, campusGuid]);

    useEffect(() => {
        if (![basicLoaded].includes(false)){
            setPageLoaded(true);
        }
    }, [basicLoaded]);

    useEffect(() => {
        if (pageLoaded && tabItem === "init"){
            setTabItem("basic");
        }
    }, [pageLoaded]);

    useEffect(() => {
        if (timezoneData.length > 0){
            let tmpOptions = [];
            for (let i=0; i<timezoneData.length; i++){
                tmpOptions.push(
                    <option key={"timezone-option-"+timezoneData[i].timezone_id.toString()}
                            value={timezoneData[i].timezone_id}>{timezoneData[i].timezone_name}
                    </option>
                );
            }
            setTimezoneOptions(() => tmpOptions);
        }
    }, [timezoneData]);

    useEffect(() => {
        setNoteCSVLink(prevState => {
            return {...prevState,
                headers: noteCSVHeaderData,
                data: noteData}
        });
    }, [noteData]);

    useEffect(() => {
        setNoteCSVButton(
            <CSVLink {...noteCSVLink} uFEFF={false}>
                <Button text={"Export"} icon={true} iconClass={"fe fe-download me-2"}
                        class={"btn btn-primary ms-2 px-4 mt-1"}/>
            </CSVLink>
        );
    }, [noteCSVLink]);

    useEffect(() => {
        let tmp = [];
        if (roleData){
            roleData.sort((a, b) => sortFunc(a, b, "user_role_weight", "asc"));
            for (let i=0; i < roleData.length; i++){
                if (iAmHigherAuthority(roleData[i]?.user_role_weight, dData.my_role_weight)) {
                    tmp.push(
                        <option key={`role-option-${i}`} value={roleData[i]?.user_role_weight}>
                            {roleData[i]?.user_role_name}
                        </option>
                    );
                }
            }
            setRoleOptions(tmp);
        }
    }, [roleData]);

    useEffect(() => {
        let tmpData = [], tmpList = [];
        if (userLoaded && myUserLoaded){
            for (let i=0; i < myUserData.length; i++){
                tmpList.push(myUserData[i]?.cognito_id);
            }
            for (let i2=0; i2 < userData.length; i2++){
                if (userData[i2]?.UserId && !tmpList.includes(userData[i2]?.UserId)){
                    tmpData.push(userData[i2]);
                }
            }
            setUserActiveData(tmpData)
        }
    }, [userData, myUserData, userLoaded, myUserLoaded]);

    useEffect(() => {
        let tmpData = [], tmpList = [];
        if (groupLoaded && myGroupLoaded){
            for (let i=0; i < myGroupData.length; i++){
                tmpList.push(myGroupData[i]?.group_guid);
            }

            for (let i2=0; i2 < groupData.length; i2++){
                if (groupData[i2]?.GroupId && !tmpList.includes(groupData[i2]?.GroupId)){
                    tmpData.push(groupData[i2]);
                }
            }
            setGroupActiveData(tmpData);
        }
    }, [groupData, myGroupData, groupLoaded, myGroupLoaded]);

    useEffect(() => {
        let myIds = [], dataSet = [], afrDevices = [];
        if (afrLoaded && devTypeLoaded && myAFRLoaded && afrData.length > 0){
            for (let i=0; i < myAFRData.length; i++){
                myIds.push(myAFRData[i]?.device_type_id);
            }
            afrDevices = afrData[0].AFRDevices;
            for (let i2=0; i2 < afrDevices.length; i2++){
                for (let i3=0; i3 < devTypeData.length; i3++){
                    if (afrDevices[i2].toLowerCase() === devTypeData[i3].device_type_name.toLowerCase() && !myIds.includes(devTypeData[i3].inovonics_type_id)){
                        dataSet.push({
                            device_type_id: devTypeData[i3].inovonics_type_id,
                            device_type_name: devTypeData[i3].device_type_name
                        });
                        break;
                    }
                }
            }
            setAFRDataSet(dataSet);
            setAFROriginIdList(myIds);
        }
    }, [afrData, afrLoaded, myAFRData, myAFRLoaded, devTypeData, devTypeLoaded]);

    useEffect(() => {
        let myIds = [], dataSet = [], hpTypes = [];
        if (hpLoaded && myHPLoaded && eventTypeLoaded && hpData.length > 0){
            for (let i=0; i < myHPData.length; i++){
                myIds.push(myHPData[i].event_type_id);
            }
            hpTypes = hpData[0].HighPriorityAlertTypes;
            for (let i2=0; i2 < hpTypes.length; i2++){
                for (let i3=0; i3 < eventTypeData.length; i3++){
                    if (((hpTypes[i2].toLowerCase() === "alert" && eventTypeData[i3].event_type_name.toLowerCase() === "emergency")
                        || (hpTypes[i2].toLowerCase() === eventTypeData[i3].event_type_name.toLowerCase()))
                        && !myIds.includes(eventTypeData[i3].event_type_id)){
                        dataSet.push({
                            event_type_name: eventTypeData[i3].event_type_name,
                            event_type_id: eventTypeData[i3].event_type_id
                        });
                        break;
                    }
                }
            }
            setHPDataSet(dataSet);
            setHPOriginIdList(myIds);
        }
    }, [hpData, myHPData, eventTypeData, hpLoaded, myHPLoaded, eventTypeLoaded]);

    useEffect(() => {
        let myIds = [], dataSet = [];
        if (reasonLoaded && myReasonLoaded && reasonData.length > 0){
            for (let i=0; i < myReasonData.length; i++){
                myIds.push(myReasonData[i].reason_code_id);
            }
            for (let i2=0; i2 < reasonData.length; i2++){
                if (!myIds.includes(parseInt(reasonData[i2].ReasonCodeId))){
                    dataSet.push({
                        reason_code_description: reasonData[i2].Description,
                        reason_code_id: parseInt(reasonData[i2].ReasonCodeId),
                        pal_reason_code_id: parseInt(reasonData[i2].GlobalReasonCode)
                    });
                }
            }
            setReasonDataSet(dataSet);
            setReasonOriginIdList(myIds);
        }
    }, [reasonData, myReasonData, reasonLoaded, myReasonLoaded]);

    useEffect(() => {
        let pRules = paginateData(userActiveData, page, perPage);
        setPRules(pRules);
        if (userActiveData.length > 0) {
            userActiveData.sort((a, b) => sortFunc(a, b, sorter.sortColumn, sorter.sortOrder));
        }
        setUserRows(<TableBody start={pRules.start} end={pRules.end} tableData={userActiveData} checkbox={addRights} unk={"b-"}
                                     writeAccess={addRights} addlEditKey={""} addlEditCheck={false} checkboxId={"uCheckUser"}
                                     actionAppearance={() => actionAppearance(pRules.start, pRules.end, ["migrateBtn"], "uCheckUser")}
                                     tableHeaders={userHeaderData} editModal={() => {}} parentComponent={"Campus"} dData={dData}
                                     modal={false} checkboxlist={userIdList} setCheckboxId={(value) => {setUserIdList(value)}}
                                     checkidkey={"UserId"} />);
    }, [userActiveData, sorter, page, perPage, userIdList]);

    useEffect(() => {
        let pRules = paginateData(groupActiveData, groupPage, perPage);
        setGroupPRules(pRules);
        if (groupActiveData.length > 0) {
            groupActiveData.sort((a, b) => sortFunc(a, b, groupSorter.sortColumn, groupSorter.sortOrder));
        }
        setGroupRows(<TableBody start={pRules.start} end={pRules.end} tableData={groupActiveData} checkbox={addRights} unk={"c-"}
                                writeAccess={addRights} addlEditKey={""} addlEditCheck={false} checkboxId={"uCheckGroup"}
                                actionAppearance={() => actionAppearance(pRules.start, pRules.end, ["migrateGroupBtn"], "uCheckGroup")}
                                tableHeaders={groupHeaderData} editModal={() => {}} parentComponent={"Campus"} dData={dData}
                                modal={false} checkboxlist={groupIdList} setCheckboxId={(value) => {setGroupIdList(value)}}
                                checkidkey={"GroupId"} />);
    }, [groupActiveData, groupSorter, groupPage, perPage, groupIdList]);

    useEffect(() => {
        if (afrDataSet.length > 0) {
            afrDataSet.sort((a, b) => sortFunc(a, b, afrSorter.sortColumn, afrSorter.sortOrder));
        }
        setAFRRows(<TableBody start={0} end={afrDataSet.length} tableData={afrDataSet} checkbox={addRights} unk={"d-"}
                                writeAccess={addRights} addlEditKey={""} addlEditCheck={false} checkboxId={"uCheckAFR"}
                                actionAppearance={() => actionAppearance(0, afrDataSet.length, ["migrateAFRBtn"], "uCheckAFR")}
                                tableHeaders={afrHeaderData} editModal={() => {}} parentComponent={"Campus"} dData={dData}
                                modal={false} checkboxlist={afrIdList} setCheckboxId={(value) => {setAFRIdList(value)}}
                                checkidkey={"device_type_id"} />);
    }, [afrDataSet, afrSorter, afrIdList]);

    useEffect(() => {
        if (hpDataSet.length > 0) {
            hpDataSet.sort((a, b) => sortFunc(a, b, hpSorter.sortColumn, hpSorter.sortOrder));
        }
        setHPRows(<TableBody start={0} end={hpDataSet.length} tableData={hpDataSet} checkbox={addRights} unk={"e-"}
                              writeAccess={addRights} addlEditKey={""} addlEditCheck={false} checkboxId={"uCheckHP"}
                              actionAppearance={() => actionAppearance(0, hpDataSet.length, ["migrateHPBtn"], "uCheckHP")}
                              tableHeaders={hpHeaderData} editModal={() => {}} parentComponent={"Campus"} dData={dData}
                              modal={false} checkboxlist={hpIdList} setCheckboxId={(value) => {setHPIdList(value)}}
                              checkidkey={"event_type_id"} />);
    }, [hpDataSet, hpSorter, hpIdList]);

    useEffect(() => {
        if (reasonDataSet.length > 0) {
            reasonDataSet.sort((a, b) => sortFunc(a, b, reasonSorter.sortColumn, reasonSorter.sortOrder));
        }
        setReasonRows(<TableBody start={0} end={reasonDataSet.length} tableData={reasonDataSet} checkbox={addRights} unk={"f-"}
                                 writeAccess={addRights} addlEditKey={""} addlEditCheck={false} checkboxId={"uCheckReason"}
                                 actionAppearance={() => actionAppearance(0, reasonDataSet.length, ["migrateReasonBtn"], "uCheckReason")}
                                 tableHeaders={reasonHeaderData} editModal={() => {}} parentComponent={"Campus"} dData={dData}
                                 modal={false} checkboxlist={reasonIdList} setCheckboxId={(value) => {setReasonIdList(value)}}
                                 checkidkey={"reason_code_id"} />);
    }, [reasonDataSet, reasonSorter, reasonIdList]);

    useEffect(() => {
        let pRules = paginateData(noteData, notesPage, notesPerPage);
        setNotesPPRules(pRules);
        if (noteData.length > 0) {
            noteData.sort((a, b) => sortFunc(a, b, noteSorter.sortColumn, noteSorter.sortOrder));
        }
        setNoteTableRows(<TableBody start={pRules.start} end={pRules.end} tableData={noteData} checkbox={addRights} unk={"n-"}
                                    writeAccess={addRights} addlEditKey={""} addlEditCheck={false} checkboxId={"uCheckNote"}
                                    actionAppearance={() => actionAppearance(pRules.start, pRules.end, ["noteDeleteBtn"], "uCheckNote")}
                                    tableHeaders={noteHeaderData} editModal={editNoteModal} parentComponent={"Campus"} dData={dData}
                                    modal={editRights} checkboxlist={noteIdList} setCheckboxId={(value) => {setNoteIdList(value)}}
                                    tzOffset={parseInt(dData?.campusData[campusId]?.tz_offset ? dData?.campusData[campusId]?.tz_offset : 0)}
                                    checkidkey={"note_id"} />);
    }, [noteData, noteSorter, noteIdList, notesPage, notesPerPage]);

    useEffect(() => {
        let isEN, isNF, isNP, isRE, isHY, isLE, isNW, isRT, isCL, isMB, isTXT, isVC, isPG, isLC, isEM, isCF, isAC, isRC, isDC, isEC, isOF, isRD, isCK;
        if (basicData?.length > 0){
            setIsCloud(() => basicData[0]?.is_cloud === 1);
            setCampusName(() => basicData[0]?.campus_name ? basicData[0]?.campus_name : "");
            setCorporateName(() => basicData[0]?.corporate_name ? basicData[0]?.corporate_name : "");
            setCorporateId(() => basicData[0]?.corporate_id ? basicData[0]?.corporate_id : "");
            setEmail(() => basicData[0]?.campus_email ? basicData[0]?.campus_email : "");
            setPhone(() => basicData[0]?.campus_phone ? basicData[0]?.campus_phone : "");
            setLatitude(() => basicData[0]?.campus_latitude ? basicData[0]?.campus_latitude : "");
            setLongitude(() => basicData[0]?.campus_longitude ? basicData[0]?.campus_longitude : "");
            setZip(() => basicData[0]?.campus_zip ? basicData[0]?.campus_zip : "");
            setCity(() => basicData[0]?.campus_city ? basicData[0]?.campus_city : "");
            setState(() => basicData[0]?.campus_state ? basicData[0]?.campus_state : "");
            setCountry(() => basicData[0]?.campus_country ? basicData[0]?.campus_country : "");
            setStreetAddr(() => basicData[0]?.campus_street_address ? basicData[0]?.campus_street_address : "");
            setServicePlan(() => basicData[0]?.date_service_plan_expire ? basicData[0]?.date_service_plan_expire : "");
            setCampusGuid(() => basicData[0]?.campus_guid ? basicData[0]?.campus_guid : "");
            setTimezone(() => basicData[0]?.timezone ? basicData[0]?.timezone : "");
            setTimezoneId(() => basicData[0]?.timezone_id ? basicData[0]?.timezone_id : "");

            isCF = !!basicData[0]?.careflow_v2;
            isAC = !!basicData[0]?.use_area_careflow;
            isRC = !!basicData[0]?.use_resident_careflow;
            isDC = !!basicData[0]?.use_device_careflow;
            isEC = !!basicData[0]?.use_event_careflow;
            isCK = !!basicData[0]?.is_resident_checkin;
            isRD = !!basicData[0]?.is_rounding;
            setCareflowV2(() => isCF);
            setAreaCareflow(() => isAC);
            setResCareflow(() => isRC);
            setDevCareflow(() => isDC);
            setEventCareflow(() => isEC);
            setCheckin(() => isCK);
            setRounds(() => isRD);
            setCSettingsOriginList(() => [isCF, isAC, isRC, isDC, isEC, isCK, isRD]);

            isHY = !!basicData[0]?.is_hybrid;
            isLE = !!basicData[0]?.show_legacy;
            isNW = !!basicData[0]?.show_new;
            isCL = !!basicData[0]?.is_cloud;
            setIsHybrid(() => isHY);
            setShowLegacy(() => isLE);
            setShowNew(() => isNW);
            setIsCloud(() => isCL);
            setPSettingsOriginList(() => [isHY, isLE, isNW, isCL]);

            isEN = !!basicData[0]?.event_notes_active;
            isNF = !!basicData[0]?.event_notes_freeform;
            isNP = !!basicData[0]?.event_notes_preform;
            isRE = !!basicData[0]?.is_reason_editable;
            isRT = !!basicData[0]?.resident_trends;
            setIsEventNotes(() => isEN);
            setIsNotesFreeform(() => isNF);
            setIsNotesPreform(() => isNP);
            setIsReasonEditable(() => isRE);
            setIsResidentTrends(() => isRT);
            setRSettingsOriginList(() => [isEN, isNF, isNP, isRE, isRT]);

            isMB = !!basicData[0]?.app_active;
            isTXT = !!basicData[0]?.text_messaging_active;
            isEM = !!basicData[0]?.email_active;
            isPG = !!basicData[0]?.pager_active;
            isVC = !!basicData[0]?.voice_active;
            isLC = !!basicData[0]?.udp_broadcast;
            isOF = !!basicData[0]?.offsite_active;
            setIsMobile(isMB);
            setIsText(isTXT);
            setIsEmail(isEM);
            setIsPager(isPG);
            setIsVoice(isVC);
            setIsLightController(isLC);
            setIsOffsite(isOF);
            setOSettingsOriginList(() => [isMB, isTXT, isEM, isPG, isVC, isLC, isOF])

            setBasicLoaded(true);
        }
    }, [basicData]);

    useEffect(() => {
        if (basicLoaded && geoLoaded && zoneTypeLoaded){
            if (tabItem === "designer"){
                document.getElementById("designer-tab-item").classList.remove("d-none");
                document.getElementById("designer-tab-item").classList.add("d-block");
            } else{
                document.getElementById("designer-tab-item").classList.add("d-none");
                document.getElementById("designer-tab-item").classList.remove("d-block");
            }
            setGeofenceMap(<GeofenceTool latitude={latitude} longitude={longitude} campusId={campusId}
                                         campus={campusName} startup={true} zoneData={geoData2} zoneTypes={zoneTypeData}
                                         setCount={setCount} />);
        }
    }, [tabItem, basicLoaded, geoLoaded, zoneTypeData, zoneTypeLoaded, geoData2, campusName]);

    useEffect(() => {
        if (tabItem === "geofence" && geoLoaded && basicLoaded){
            let colorArray = ["#1f98ff", "#58c2ff", "#98d3ff", "#259400", "#deb900", "#d02400"];
            let dataset = Object.values(geoData);
            setMapCont(() =>
               <MapContainer className={"rounded"}
                          zoom={19}
                          id={"event-map-container"}
                          scrollWheelZoom={true}
                          center={[latitude, longitude]}>
                    {/*<TileLayer*/}
                    {/*    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'*/}
                    {/*    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>*/}
                   <ReactLeafletGoogleLayer apiKey={"AIzaSyDWuEm0U-KbxGBwYlNyc3eiKM1lbWcocis"} type={"roadmap"} />
                   <LayersControl position={"topright"}>
                       {dataset.map((value) => {
                           let inset = Object.values(value);
                           return (
                               <LayersControl.Overlay checked name={`${value?.zone_type_name}`}>
                                   <LayerGroup>
                                       {inset.map((invalue) => {
                                           if (invalue === value?.zone_type_name){
                                               return <></>;
                                           }
                                           return (
                                               <Polygon positions={invalue?.positions}
                                                        pathOptions={{color: colorArray[invalue?.layer]}}>
                                                    <Tooltip>{invalue?.zone_name}</Tooltip>
                                                </Polygon>
                                           )
                                       })}
                                   </LayerGroup>
                               </LayersControl.Overlay>
                           )
                       })}
                   </LayersControl>
            </MapContainer>
           );
        }
    }, [tabItem, geoData, clickedLatLng]);

    useEffect(() => {
        setPSettingsList([isHybrid, showLegacy, showNew, isCloud]);
    }, [isHybrid, showLegacy, showNew, isCloud]);

    useEffect(() => {
        setRSettingsList([isEventNotes, isNotesFreeform, isNotesPreform, isReasonEditable, isResidentTrends]);
    }, [isEventNotes, isNotesFreeform, isNotesPreform, isReasonEditable, isResidentTrends]);

    useEffect(() => {
        setOSettingsList([isMobile, isText, isEmail, isPager, isVoice, isLightController, isOffsite]);
    }, [isMobile, isText, isEmail, isPager, isVoice, isLightController, isOffsite]);

    useEffect(() => {
        setCSettingsList([careflowV2, areaCareflow, resCareflow, devCareflow, eventCareflow, checkin, rounds]);
    }, [careflowV2, areaCareflow, resCareflow, devCareflow, eventCareflow, checkin, rounds]);

    useEffect(() => {
        if (arraysEqual(pSettingList, pSettingsOriginList)){
            document.getElementById("p-settings-btn").classList.add("d-none");
            document.getElementById("p-settings-cancel-btn").classList.add("d-none");
        }else{
            document.getElementById("p-settings-btn").classList.remove("d-none");
            document.getElementById("p-settings-cancel-btn").classList.remove("d-none");
        }
    }, [pSettingList, pSettingsOriginList]);

    useEffect(() => {
        if (arraysEqual(rSettingList, rSettingsOriginList)){
            document.getElementById("r-settings-btn").classList.add("d-none");
            document.getElementById("r-settings-cancel-btn").classList.add("d-none");
        }else{
            document.getElementById("r-settings-btn").classList.remove("d-none");
            document.getElementById("r-settings-cancel-btn").classList.remove("d-none");
        }
    }, [rSettingList, rSettingsOriginList]);

    useEffect(() => {
        if (arraysEqual(oSettingsList, oSettingsOriginList)){
            document.getElementById("o-settings-btn").classList.add("d-none");
            document.getElementById("o-settings-cancel-btn").classList.add("d-none");
        }else{
            document.getElementById("o-settings-btn").classList.remove("d-none");
            document.getElementById("o-settings-cancel-btn").classList.remove("d-none");
        }
    }, [oSettingsList, oSettingsOriginList]);

    useEffect(() => {
        if (arraysEqual(cSettingsList, cSettingsOriginList)){
            document.getElementById("c-settings-btn").classList.add("d-none");
            document.getElementById("c-settings-cancel-btn").classList.add("d-none");
        }else{
            document.getElementById("c-settings-btn").classList.remove("d-none");
            document.getElementById("c-settings-cancel-btn").classList.remove("d-none");
        }
    }, [cSettingsList, cSettingsOriginList]);

    useEffect(() => {
        setCountryOptionsFunction(country);
    }, [country]);

    useEffect(() => {
        let i, tmp = [];
        for (i = 0; i < corpData?.length; i++){
            tmp.push(
                <option key={"location-option"+i.toString()} value={corpData[i].corporate_id}>{corpData[i].corporate_name}</option>
            );
        }
        setCorporateOptions(() => tmp);
    }, [corpData]);

    useEffect(() => {
        if (onboardSignCheck === true){
            let interval = null;
            interval = setInterval(() => {
                 setSignCheckCount(signCheckCount => signCheckCount - 1);
            }, 1000);
            if (signCheckCount <= 0){
                let item = yesIntegrations[onboardIndex];
                ApiRequester({reqEndpoint: "myfetch", pKey: "file_id", pVal: onboardFileId, Tbl: "ext_ehr_file_control",
                                procedure: "fetchbyparameter", reqType: "direct", "read-only": false}).then(data => {
                    if (data && data.length > 0){
                        if (["completed", "completed_with_errors"].includes(data[0]?.status)){
                            if (data[0]?.status === "completed_with_errors"){
                                toast.warn(`File created successfully, however: ${data?.error_message}`);
                            }else{
                                toast.success("File created successfully");
                            }
                            ApiRequester({reqEndpoint: "int-onboarding", action: "get_presigned_url", async: false,
                                campus_id: campusId, corporate_id: corporateId, file_id: data[0].file_id,
                                client_id: item.external_campus_id, data_type: "all", user_id: dData.user, vendor_id: item.vendor_id}).then(data => {
                                if (data && !Array.isArray(data) && data?.presigned_url){
                                    setOnboardSignUrl(data.presigned_url);
                                    setOnboardSignCheck(false);
                                    setOnboardFileId("");
                                    setSignCheckCount(0);
                                }
                                else{
                                    formFail(`Error fetching presigned url, error code: ${data[1]}`, "addNoteSubmit", "loadAddNoteSubmit");
                                }
                            });
                        }else if (data[0]?.status === "failed"){
                            setOnboardSignCheck(false);
                            setOnboardFileId("");
                            setSignCheckCount(0);
                            toast.error(data?.error_message);
                        }else{

                        }
                    }
                });
                setSignCheckCount(5);
            }
            return () => clearInterval(interval);
        }
    }, [onboardSignCheck, signCheckCount]);

    useEffect(() => {
        if (onboardSignUrl !== ""){
            const url = onboardSignUrl;
            setOnboardSignUrl(""); // clear immediately so we don't re-run with same URL
            toggleOnboardingButtons(onboardIndex, false);
            handleSubmitActions(`onboarding-load-${onboardIndex}`, `onboarding-d-${onboardIndex}`);
            fetch(url)
                .then((res) => {
                    if (!res.ok) throw new Error(`Download failed: ${res.status}`);
                    return res.blob();
                })
                .then((blob) => {
                    const objectUrl = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = objectUrl;
                    a.download = "onboarding-template.xlsx";
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(objectUrl);
                })
                .catch((err) => {
                    console.error("Onboarding template download error:", err);
                    toast.error("Failed to download onboarding template. Please try again.");
                });
        }
    }, [onboardSignUrl]);

    useEffect(() => {
        if (onboardUploadCheck){
            let interval = null;
            interval = setInterval(() => {
                 setUploadCheckCount(uploadCheckCount => uploadCheckCount - 1);
            }, 1000);
            if (uploadCheckCount <= 0){
                ApiRequester({reqEndpoint: "myfetch", pKey: "file_id", pVal: onboardUploadFileId, Tbl: "ext_ehr_file_control",
                                procedure: "fetchbyparameter", reqType: "direct", "read-only": false}).then(data => {
                    if (data && data.length > 0){
                        if (["completed", "completed_with_errors"].includes(data[0]?.status)){
                            setOnboardUploadFileId("");
                            setOnboardUploadCheck(false);
                            if (data[0]?.status === "completed_with_errors"){
                                toast.warn(`Upload successful, however: ${data?.error_message}`);
                            }else{
                                toast.success("Upload successful");
                            }
                            handleSubmitActions("loadUploadOnboardSubmit", "uploadOnboardSubmit");
                            document.getElementById("uploadOnboardCancel").click();
                        }else if (data[0]?.status === "failed"){
                            setOnboardUploadFileId("");
                            setOnboardUploadCheck(false);
                            toast.error(data?.error_message);
                            handleSubmitActions("loadUploadOnboardSubmit", "uploadOnboardSubmit");
                            document.getElementById("uploadOnboardCancel").click();
                        }else{

                        }
                    }
                });
                setUploadCheckCount(5);
            }
            return () => clearInterval(interval);
        }
    }, [onboardUploadCheck, uploadCheckCount]);

    function setCountryOptionsFunction(inCountry){
        let tmp = [];
        let stateData = getStatesByCountry(inCountry);
        for (let i=0; i < stateData?.length; i++){
            tmp.push(
                <option key={"state-option"+i} value={stateData[i][0]}>{stateData[i][1]}</option>
            );
        }
        setStateOptions(tmp);
        setZipReg(getZipRegexByCountry(inCountry));
    }

   function basicActionHandling(){
        document.getElementById("name-static").classList.toggle("d-none");
        document.getElementById("name-edit").classList.toggle("d-none");
        document.getElementById("corporate-static").classList.toggle("d-none");
        document.getElementById("corporate-edit").classList.toggle("d-none");
        document.getElementById("country-static").classList.toggle("d-none");
        document.getElementById("country-edit").classList.toggle("d-none");
        document.getElementById("street-static").classList.toggle("d-none");
        document.getElementById("street-edit").classList.toggle("d-none");
        document.getElementById("state-static").classList.toggle("d-none");
        document.getElementById("state-edit").classList.toggle("d-none");
        document.getElementById("city-static").classList.toggle("d-none");
        document.getElementById("city-edit").classList.toggle("d-none");
        document.getElementById("zipcode-static").classList.toggle("d-none");
        document.getElementById("zipcode-edit").classList.toggle("d-none");
        document.getElementById("timezone-static").classList.toggle("d-none");
        document.getElementById("timezone-edit").classList.toggle("d-none");
        document.getElementById("email-static").classList.toggle("d-none");
        document.getElementById("email-edit").classList.toggle("d-none");
        document.getElementById("phone-static").classList.toggle("d-none");
        document.getElementById("phone-edit").classList.toggle("d-none");
        if (document.getElementById("edit-basic-btn").innerText === "Edit"){
            document.getElementById("edit-basic-btn").innerText = "Cancel";
            document.getElementById("save-basic-btn").classList.toggle("d-none");
            document.getElementById("name-edit").value = campusName;
            document.getElementById("corporate-edit").value = corporateId;
            document.getElementById("country-edit").value = country;
            document.getElementById("street-edit").value = streetAddr;
            document.getElementById("state-edit").value = state;
            document.getElementById("city-edit").value = city;
            document.getElementById("zipcode-edit").value = zipcode;
            document.getElementById("timezone-edit").value = timezoneId;
            document.getElementById("email-edit").value = email;
            document.getElementById("phone-edit").value = phone.replaceAll("-", "");
        }else{
            document.getElementById("edit-basic-btn").innerText = "Edit";
            document.getElementById("save-basic-btn").classList.toggle("d-none");
        }
        formCheck("basic-form", "save-basic-btn");
   }

    function basicSubmit(){
        let name, countryX, stateX, cityX, zipX, emailX, phoneX, addressX, corpId, payload, tzId, oldPayload;
        if (editRights){
            handleSubmitActions("save-basic-btn", "load-basic-btn");
            name = document.getElementById("name-edit")?.value;
            addressX = document.getElementById("street-edit")?.value;
            countryX = document.getElementById("country-edit")?.value;
            stateX = document.getElementById("state-edit")?.value;
            cityX = document.getElementById("city-edit")?.value;
            zipX = document.getElementById("zipcode-edit")?.value;
            emailX = document.getElementById("email-edit")?.value;
            phoneX = document.getElementById("phone-edit")?.value;
            corpId = document.getElementById("corporate-edit")?.value;
            tzId = document.getElementById("timezone-edit").value;
            payload = [{campus_id: parseInt(campusId), corporate_id: parseInt(corpId), campus_country: countryX,
                        campus_state: stateX, campus_name: name, campus_city: cityX, campus_zip: zipX,
                        campus_email: emailX, campus_phone: phoneX, timezone_id: parseInt(tzId),
                        modified_by: dData.user, campus_street_address: addressX}];
            oldPayload = [{campus_id: parseInt(campusId), corporate_id: corporateId, campus_country: country,
                           campus_state: state, campus_name: campusName, campus_city: city, campus_zip: zipcode,
                           campus_email: email, campus_phone: phone, timezone_id: timezoneId,
                           campus_street_address: streetAddr}];
            ApiRequester({reqEndpoint: "mytransaction", TransType: "campus_edit", Payload: payload, OldPayload: oldPayload,
                                CampusId: dData.acnt, User: dData.user, ClientId: dData.sessionId}).then(data => {
                if (data && data[0]){
                    setRead(false);
                    setCount(0);
                    formSuccess("Basic information saved.", "save-basic-btn", "load-basic-btn",
                        "edit-basic-btn");
                }
                else{
                    formFail(`Error during save, error code: ${data && data?.length > 1 ? data[1] : ""}`,
                        "save-basic-btn", "load-basic-btn");
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function platformSettingSubmit(){
        let payload, oldPayload;
        handleSubmitActions("p-settings-btn", "p-settings-load-btn");
        payload = [{campus_id: parseInt(campusId), is_hybrid: isHybrid ? 1 : 0, show_legacy: showLegacy ? 1 : 0,
                    show_new: showNew ? 1 : 0, is_cloud: isCloud ? 1 : 0, modified_by: dData?.user}];
        oldPayload = [{campus_id: parseInt(campusId), is_hybrid: pSettingsOriginList[0] ? 1 : 0,
                      show_legacy: pSettingsOriginList[1] ? 1 : 0, show_new: pSettingsOriginList[2] ? 1 : 0,
                      is_cloud: pSettingsOriginList[3] ? 1 : 0}];
        ApiRequester({reqEndpoint: "mysave", Tbl: "core_campus", Payload: payload, OldPayload: oldPayload,
                            urlType: "POST", User: dData.user, PKey: "campus_id", Condition: "primary", CampusId: campusId,
                            ClientId: dData.sessionId}).then(data => {
            if (data && data[0]){
                setRead(false);
                setCount(0);
                formSuccess("Platform settings saved.", "p-settings-btn", "p-settings-load-btn");
                if (dData?.corp === corporateId){
                    reloadSessionCampusItems(campusId, ["is_hybrid", "show_legacy", "show_new", "is_cloud"],
                        [isHybrid, showLegacy, showNew, isCloud], false)
                }
            }
            else{
                formFail(`Error during save, error code: ${data && data?.length > 1 ? data[1] : ""}`,
                    "p-settings-btn", "p-settings-load-btn");
            }
        });
    }

    function reportSettingsSubmit(){
        let payload, oldPayload;
        handleSubmitActions("r-settings-btn", "r-settings-load-btn");
        payload = [{campus_id: parseInt(campusId), event_notes_active: isEventNotes ? 1 : 0,
                    event_notes_freeform: isNotesFreeform ? 1 : 0, event_notes_preform: isNotesPreform ? 1 : 0,
                    is_reason_editable: isReasonEditable ? 1 : 0, resident_trends: isResidentTrends ? 1 : 0,
                    modified_by: dData?.user}];
        oldPayload = [{campus_id: parseInt(campusId), event_notes_active: rSettingsOriginList[0] ? 1 : 0,
                       event_notes_freeform: rSettingsOriginList[1] ? 1 : 0, event_notes_preform: rSettingsOriginList[2] ? 1 : 0,
                       is_reason_editable: rSettingsOriginList[3] ? 1 : 0, resident_trends: rSettingsOriginList[4] ? 1 : 0}];
        ApiRequester({reqEndpoint: "mysave", Tbl: "core_campus", Payload: payload, OldPayload: oldPayload,
                            urlType: "POST", User: dData.user, PKey: "campus_id", Condition: "primary", CampusId: campusId,
                            ClientId: dData.sessionId}).then(data => {
            if (data && data[0]){
                setRead(false);
                setCount(0);
                formSuccess("Reporting settings saved.", "r-settings-btn", "r-settings-load-btn");
                if (dData?.corp === corporateId){
                    reloadSessionCampusItems(campusId, ["event_notes_active", "event_notes_freeform", "event_notes_preform", "is_reason_editable", "resident_trends"],
                        [isEventNotes, isNotesFreeform, isNotesPreform, isReasonEditable, isResidentTrends], false);
                    // update session direct here
                }
            }
            else{
                formFail(`Error during save, error code: ${data && data?.length > 1 ? data[1] : ""}`,
                    "r-settings-btn", "r-settings-load-btn");
            }
        });
    }

    function outputSettingsSubmit(){
        let payload, oldPayload;
        handleSubmitActions("o-settings-btn", "o-settings-load-btn");
        payload = [{campus_id: parseInt(campusId), app_active: isMobile ? 1 : 0,
                    text_messaging_active: isText ? 1 : 0, email_active: isEmail ? 1 : 0,
                    pager_active: isPager ? 1 : 0, voice_active: isVoice ? 1 : 0, offsite_active: isOffsite ? 1 : 0,
                    udp_broadcast: isLightController ? 1 : 0, modified_by: dData?.user}];
        oldPayload = [{campus_id: parseInt(campusId), app_active: oSettingsOriginList[0] ? 1 : 0,
                       text_messaging_active: oSettingsOriginList[1] ? 1 : 0, email_active: oSettingsOriginList[2] ? 1 : 0,
                       pager_active: oSettingsOriginList[3] ? 1 : 0, voice_active: oSettingsOriginList[4] ? 1 : 0,
                       udp_broadcast: oSettingsOriginList[5] ? 1 : 0, offsite_active: oSettingsOriginList[6] ? 1 : 0}];
        ApiRequester({reqEndpoint: "mysave", Tbl: "core_campus", Payload: payload, OldPayload: oldPayload,
                            urlType: "POST", User: dData.user, PKey: "campus_id", Condition: "primary", CampusId: campusId,
                            ClientId: dData.sessionId}).then(data => {
            if (data && data[0]){
                setRead(false);
                setCount(0);
                formSuccess("Output feature settings saved.", "o-settings-btn", "o-settings-load-btn");
                if (dData?.corp === corporateId){
                    reloadSessionCampusItems(campusId, ["app_active", "text_messaging_active", "email_active", "pager_active", "voice_active", "udp_broadcast", "offsite_active"],
                        [isMobile, isText, isEmail, isPager, isVoice, isLightController, isOffsite], [oSettingsOriginList[5] !== isLightController].includes(true))
                }
            }
            else{
                formFail(`Error during save, error code: ${data && data?.length > 1 ? data[1] : ""}`,
                    "o-settings-btn", "o-settings-load-btn");
            }
        });
    }

    function careflowSettingsSubmit(){
        let payload, oldPayload;
        handleSubmitActions("c-settings-btn", "c-settings-load-btn");
        payload = [{campus_id: parseInt(campusId), careflow_v2: careflowV2 ? 1 : 0,
                    use_area_careflow: areaCareflow ? 1 : 0, use_resident_careflow: resCareflow ? 1 : 0,
                    use_device_careflow: devCareflow ? 1 : 0, use_event_careflow: eventCareflow ? 1 : 0,
                    is_resident_checkin: checkin, is_rounding: rounds}];
        oldPayload = [{campus_id: parseInt(campusId), careflow_v2: cSettingsOriginList[0] ? 1 : 0,
                       use_area_careflow: cSettingsOriginList[1] ? 1 : 0, use_resident_careflow: cSettingsOriginList[2] ? 1 : 0,
                       use_device_careflow: cSettingsOriginList[3] ? 1 : 0, use_event_careflow: cSettingsOriginList[4] ? 1 : 0,
                       is_resident_checkin: cSettingsOriginList[5] ? 1 : 0, is_rounding: cSettingsOriginList[6] ? 1 : 0}];
        ApiRequester({reqEndpoint: "mytransaction", TransType: "campus_careflow_settings", Payload: payload,
                            OldPayload: oldPayload,
                            CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
            if (data && data[0]){
                setRead(false);
                setCount(0);
                formSuccess("Careflow campus settings saved.", "c-settings-btn", "c-settings-load-btn");
                if (dData?.corp === corporateId){
                    reloadSessionCampusItems(campusId, ["careflow_v2", "use_area_careflow", "use_resident_careflow",
                            "use_device_careflow", "use_event_careflow", "is_resident_checkin", "is_rounding"],
                        [careflowV2, areaCareflow, resCareflow, devCareflow, eventCareflow, checkin, rounds], [cSettingsOriginList[0] !== careflowV2].includes(true))
                }
            }
            else{
                formFail(`Error during save, error code: ${data && data?.length > 1 ? data[1] : ""}`,
                    "c-settings-btn", "c-settings-load-btn");
            }
        });
    }

    function getGroupIdListByGuidList(userRec){
       let idList = [];
       for (let i=0; i < myGroupData?.length; i++){
           if (userRec?.GroupIds && userRec?.GroupIds.includes(myGroupData[i]?.group_guid)){
               if (!idList.includes(myGroupData[i]?.group_id)){
                   idList.push(myGroupData[i]?.group_id);
               }
           }
       }
       return idList;
    }

    function migratePerformSubmit(){
        let payload = [], role, pAccess, groupIds;
        if (addRights){
            handleSubmitActions("confirmModalSubmit", "loadConfirmModalSubmit");
            for (let i=0; i < userActiveData.length; i++){
                if (userIdList.includes(userActiveData[i]?.UserId)){
                    switch (userActiveData[i]?.UserRole) {
                        case "admin": role = 5; break;
                        case "corporate": role = 4; break;
                        case "corporate-admin": role = 3; break;
                        case "palcare": role = 3; break;
                        case "palcare-admin": role = 1; break;
                        default: role = 6; break;
                    }
                    pAccess = getAccessSettings(parseInt(role));
                    groupIds = getGroupIdListByGuidList(userActiveData[i]);
                    payload.push({Action: "migrate", DisplayName: userActiveData[i]?.DisplayName,
                        UserEmail: userActiveData[i]?.UserEmail ? userActiveData[i]?.UserEmail : "", UserRole: parseInt(role), UserId: userActiveData[i]?.UserId,
                        Migrated: true, CampusGuid: basicData[0]?.campus_guid, PortalAccess: pAccess,
                        GroupIds: groupIds, Username: userActiveData[i]?.UserName, CampusId: campusId, ClientId: dData.sessionId})
                }
            }
            ApiRequester({reqEndpoint: "user-manage", Payload: payload}).then(data => {
                setRead(false);
                if (data[0]){
                    formSuccess("All users migrated.", "confirmModalSubmit", "loadConfirmModalSubmit", "confirmModalConfirmClose");
                    setCount(0);
                    setCount2(0);
                    document.getElementById("uCheckHead").checked = false;
                    checkAll(0, ppRules.end);
                    actionAppearance(0, ppRules.end, ["migrateBtn"]);
                }
                else{
                    formFail(`Error during migration, check user table.`, "confirmModalSubmit", "loadConfirmModalSubmit");
                    setCount(0);
                    setCount2(0);
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function migrateGroupPerformSubmit(){
        let payload = [];
        if (addRights){
            handleSubmitActions("confirmModalSubmit", "loadConfirmModalSubmit");
            for (let i=0; i < groupActiveData.length; i++){
                if (groupIdList.includes(groupActiveData[i]?.GroupId)){
                    payload.push({campus_id: campusId, group_name: groupActiveData[i]?.GroupName,
                        capcode: groupActiveData[i]?.CapCode, group_guid: groupActiveData[i]?.GroupId});
                }
            }
            ApiRequester({reqEndpoint: "mytransaction", TransType: "group_add", Payload: payload,
                                CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                setRead(false);
                if (data[0]){
                    formSuccess("Groups migrated successfully.", "confirmModalSubmit", "loadConfirmModalSubmit", "confirmModalConfirmClose");
                    setCount(0);
                    setCount2(0);
                    document.getElementById("uCheckHead2").checked = false;
                    checkAll(0, ppRules.end);
                    actionAppearance(0, ppRules.end, ["migrateGroupBtn"]);
                }
                else{
                    formFail(`Error during migration, check group table.`, "confirmModalSubmit", "loadConfirmModalSubmit");
                    setCount(0);
                    setCount2(0);
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function migrateAFRPerformSubmit(){
        let payload = [], oldPayload, tmpAfrList = [], newAfrList = [];
        if (addRights){
            handleSubmitActions("confirmModalSubmit", "loadConfirmModalSubmit");
            tmpAfrList = afrIdList.concat(afrOriginIdList);
            for (let i=0; i < tmpAfrList.length; i++){
                newAfrList.push(`${tmpAfrList[i]}-1`);
            }
            payload = [{campus_id: campusId, afr_entities: newAfrList}];
            oldPayload = [{campusId: campusId, afr_entities: afrOriginIdList}];
            ApiRequester({reqEndpoint: "mytransaction", TransType: "afrSave", Payload: payload,
                                OldPayload: oldPayload,
                                CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                setRead(false);
                if (data[0]){
                    formSuccess("AFR devices migrated successfully.", "confirmModalSubmit", "loadConfirmModalSubmit", "confirmModalConfirmClose");
                    setCount(0);
                    setCount2(0);
                    document.getElementById("uCheckHead3").checked = false;
                    checkAll(0, afrDataSet.length);
                    actionAppearance(0, afrDataSet.length, ["migrateAFRBtn"]);
                }
                else{
                    formFail(`Error during migration, check afr table.`, "confirmModalSubmit", "loadConfirmModalSubmit");
                    setCount(0);
                    setCount2(0);
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function migrateHPPerformSubmit(){
        let payload = [], oldPayload;
        if (addRights){
            handleSubmitActions("confirmModalSubmit", "loadConfirmModalSubmit");
            payload = [{campus_id: campusId, priority_entities: hpIdList.concat(hpOriginIdList)}];
            oldPayload = [{campusId: campusId, priority_entities: hpOriginIdList}];
            ApiRequester({reqEndpoint: "mytransaction", TransType: "prioritySave", Payload: payload,
                                OldPayload: oldPayload,
                                CampusId: campusId, User: dData.user, ClientId: dData.sessionId}).then(data => {
                setRead(false);
                if (data[0]){
                    formSuccess("High priority alert types migrated successfully.", "confirmModalSubmit", "loadConfirmModalSubmit", "confirmModalConfirmClose");
                    setCount(0);
                    setCount2(0);
                    document.getElementById("uCheckHead4").checked = false;
                    checkAll(0, hpDataSet.length);
                    actionAppearance(0, hpDataSet.length, ["migrateHPBtn"]);
                }
                else{
                    formFail(`Error during migration, check high priority table.`, "confirmModalSubmit", "loadConfirmModalSubmit");
                    setCount(0);
                    setCount2(0);
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function migrateReasonPerformSubmit(){
        let payload = [];
        if (addRights){
            handleSubmitActions("confirmModalSubmit", "loadConfirmModalSubmit");
            for (let i=0; i < reasonDataSet.length; i++){
                if (reasonIdList.includes(reasonDataSet[i].reason_code_id.toString())){
                    payload.push({
                        reason_code_description: reasonDataSet[i].reason_code_description,
                        pal_reason_code_id: reasonDataSet[i].pal_reason_code_id,
                        reason_code_id: reasonDataSet[i].reason_code_id,
                        campus_id: campusId
                    });
                }
            }
            ApiRequester({reqEndpoint: "mysave", Tbl: "core_reason_codes", Payload: payload, urlType: "PUT",
                            User: dData.user, PKey: "cloud_reason_code_id", Condition: "primary", CampusId: campusId,
                            ClientId: dData.sessionId}).then(data => {
                setRead(false);
                if (data[0]){
                    formSuccess("Reason codes migrated successfully.", "confirmModalSubmit", "loadConfirmModalSubmit", "confirmModalConfirmClose");
                    setCount(0);
                    setCount2(0);
                    document.getElementById("uCheckHead5").checked = false;
                    actionAppearance(0, reasonDataSet.length, ["migrateReasonBtn"]);
                    checkAll(0, reasonDataSet.length);
                }
                else{
                    formFail(`Error during migration, check reason code table.`, "confirmModalSubmit", "loadConfirmModalSubmit");
                    setCount(0);
                    setCount2(0);
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function migrateAlertPerformSubmit(){
        let payload = [], customPayload = [], acceptOn, finishOn, reasonOn, releaseTimer, finishTimer, clearTimer;
        if (addRights){
            handleSubmitActions("confirmModalSubmit", "loadConfirmModalSubmit");
            acceptOn = alertData[0]?.AcceptButtonEnabled ? 1 : 0;
            finishOn = alertData[0]?.FinishButtonEnabled ? 1 : 0;
            reasonOn = alertData[0]?.ReasonCodeEnabled ? 1 : 0;
            releaseTimer = alertData[0]?.ReleaseTimeInterval ? alertData[0].ReleaseTimeInterval : 60;
            finishTimer = alertData[0]?.FinishTimeInterval ? alertData[0].FinishTimeInterval : 60;
            clearTimer = alertData[0]?.ClearTimeInterval ? alertData[0].ClearTimeInterval : 59;
            payload = [{campus_id: campusId, accept_required: acceptOn, finish_required: finishOn,
                        reason_required: reasonOn, release_timeout: parseInt(releaseTimer)*60,
                        finish_timeout: parseInt(finishTimer)*60, clear_timeout: parseInt(clearTimer)*60}];
            ApiRequester({reqEndpoint: "mysave", Tbl: "core_campus_alert_settings", Payload: payload, urlType: "PUT",
                            User: dData.user, PKey: "alert_setting_id", Condition: "primary", CampusId: campusId,
                            ClientId: dData.sessionId}).then(data => {
                setRead(false);
                if (data[0]){
                    formSuccess("Alert settings migrated successfully.", "confirmModalSubmit", "loadConfirmModalSubmit", "confirmModalConfirmClose");
                    setCount(0);
                    setCount2(0);
                }
                else{
                    formFail(`Error during migration, check alert settings.`, "confirmModalSubmit", "loadConfirmModalSubmit");
                    setCount(0);
                    setCount2(0);
                }
            });
            customPayload = [{campus_id: campusId, is_name_editable: 0, is_group_editable: 0, modified_by: dData.user}];
            ApiRequester({reqEndpoint: "mysave", Tbl: "core_campus", Payload: customPayload, urlType: "POST",
                            User: dData.user, PKey: "campus_id", Condition: "primary", CampusId: campusId,
                            ClientId: dData.sessionId}).then(data => {
                setRead(false);
                if (data[0]){
                    formSuccess("Custom settings migrated successfully.", "confirmModalSubmit", "loadConfirmModalSubmit", "confirmModalConfirmClose");
                    setCount(0);
                    setCount2(0);
                }
                else{
                    formFail(`Error during migration, check custom settings.`, "confirmModalSubmit", "loadConfirmModalSubmit");
                    setCount(0);
                    setCount2(0);
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function handleFileUpload(){
        let file, filereader, filedatareader;
        if (editRights){
            file = document.getElementById('file-upload').files[0];
            if (file){
                setNewFileName(() => file?.name ? file.name : "");
                setNewFileExt(() => file?.name ? file.name.split(".")[1] : "");
                setFileValid(false);
                filedatareader = new FileReader();
                filedatareader.onload = function(event) {
                    let csvData = event?.target?.result;
                    let parsedData = csvData ? Papa.parse(csvData, {header: true}).data : [];
                    setNewFileData(() => parsedData);
                }
                filedatareader.readAsText(file);
                filereader = new FileReader();
                filereader.onload = function(event) {
                    let csvData = event.target.result;
                    setNewFile(() => Papa.parse(csvData).data[0][1]);
                }
                filereader.readAsDataURL(file);
            }
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function uploadSubmit(){
        if (editRights){
            handleSubmitActions("uploadSubmit", "loadUploadSubmit");
            let payload = {upload_file: newFile, upload_areas: addAreas, upload_residents: addResidents,
                            upload_devices: addDevices};
            ApiRequester({reqEndpoint: "uploadprocess", Payload: payload, User: dData.user,
                                CampusId: campusId, Process: "init"}).then(data => {
                setRead(false);
                if (data && (!Array.isArray(data) || data.length > 0)){
                    toast.info("File upload in process, awaiting results");
                    setUploadKey(() => data);
                    setUploadTimer(() => 120);
                }
                else{
                    formFail(`Error during file upload: ${data[1]}`, "uploadSubmit", "loadUploadSubmit");
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function handleOnboardFileUpload(){
        const fileInput = document.getElementById("onboard-file-upload");
        const file = fileInput?.files?.[0];
        if (file) {
            setNewOnboardUploadFileName(file.name);
            setOnboardUploadFile(file);
        } else {
            setNewOnboardUploadFileName("");
            setOnboardUploadFile(null);
        }
    }

    function onboardFileUploadSubmit(){
        const item = yesIntegrations[onboardIndex];
        handleSubmitActions("uploadOnboardSubmit", "loadUploadOnboardSubmit");
        ApiRequester({reqEndpoint: "int-onboard-upload", action: "get_upload_url", type: "EHR", async: false,
            campus_id: campusId, corporate_id: corporateId, data_type: "all",
            user_id: dData.user, vendor_id: item.vendor_id}).then((data) => {
            if (data?.presigned_upload_url) {
                const uploadUrl = data.presigned_upload_url;
                fetch(uploadUrl, {method: "PUT", body: onboardUploadFile, headers: {
                        "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}}).then((res) => {
                    if (!res.ok) {
                        throw new Error(`Upload failed: ${res.status}`);
                    }
                    if (data?.upload_id) {
                        setOnboardUploadFileId(data.upload_id);
                        ApiRequester({reqEndpoint: "int-onboard-upload", action: "process_upload", type: "EHR", async: true,
                            campus_id: campusId, corporate_id: corporateId, data_type: "all", upload_id: data.upload_id,
                            s3_bucket: data.s3_bucket, s3_key: data.s3_key,
                            user_id: dData.user, vendor_id: item.vendor_id}).then((data) => {
                                toast.info("File upload processing, this may take several minutes.")
                                setUploadCheckCount(0);
                                setOnboardUploadCheck(true);
                        });
                    }
                }).catch((err) => {
                    console.error("Onboard upload to file storage error:", err);
                    formFail("Failed to upload file to storage. Please try again.", "uploadOnboardSubmit", "loadUploadOnboardSubmit");
                });
            }else{
                formFail(`Error getting upload URL: ${data?.message}`, "uploadOnboardSubmit", "loadUploadOnboardSubmit");
            }
        });
    }

    function uploadPrecheck(){
        let error = false;
        let charTest = /[\/\\,\."\.]/;
        if (newFileData.length <= 0){
            toast.error("File empty");
            error = true;
        }
        if (!error){
            for (let i=0; i < newFileData.length; i++){
                if (newFileData[i]?.room !== undefined && newFileData[i].room !== ""){
                    if (newFileData[i]?.areatype === undefined || newFileData[i]?.areatype === ""){
                        toast.error(`Missing areatype for row ${i+2}`);
                        error = true;
                        break;
                    }else if (!["other", "access", "mc", "al", "il", "snf", "common"].includes(newFileData[i]?.areatype?.toLowerCase())){
                        toast.error(`Invalid areatype for row ${i+2}`);
                        error = true;
                        break;
                    }else if (charTest.test(newFileData[i]?.room)){
                        toast.error(`Erroneous character in room for row ${i+2}`);
                        error = true;
                        break;
                    }
                }
                if (newFileData[i]?.firstname !== undefined && newFileData[i]?.firstname !== ""){
                    if (newFileData[i]?.lastname === undefined || newFileData[i]?.lastname === ""){
                        toast.error(`Missing lastname for row ${i+2}`);
                        error = true;
                        break;
                    }else if (charTest.test(newFileData[i]?.firstname)){
                        toast.error(`Erroneous character in firstname for row ${i+2}`);
                        error = true;
                        break;
                    }else if (charTest.test(newFileData[i]?.lastname)){
                        toast.error(`Erroneous character in lastname for row ${i+2}`);
                        error = true;
                        break;
                    }
                }
                if (newFileData[i]?.lastname !== undefined && newFileData[i]?.lastname !== ""){
                    if (newFileData[i]?.firstname === undefined || newFileData[i]?.firstname === ""){
                        toast.error(`Missing firstname for row ${i+2}`);
                        error = true;
                        break;
                    }else if (charTest.test(newFileData[i]?.lastname)){
                        toast.error(`Erroneous character in lastname for row ${i+2}`);
                        error = true;
                        break;
                    }else if (charTest.test(newFileData[i]?.firstname)){
                        toast.error(`Erroneous character in firstname for row ${i+2}`);
                        error = true;
                        break;
                    }
                }
                if (newFileData[i]?.deviceuse !== undefined && newFileData[i]?.deviceuse !== ""){
                    if (newFileData[i]?.serial === undefined || newFileData[i]?.serial === ""){
                        toast.error(`Missing serial for row ${i+2}`);
                        error = true;
                        break;
                    }
                }
                if (newFileData[i]?.serial !== undefined && newFileData[i]?.serial !== ""){
                    if (newFileData[i]?.deviceuse === undefined || newFileData[i]?.deviceuse === ""){
                        toast.error(`Missing deviceuse for row ${i+2}`);
                        error = true;
                        break;
                    }
                }
            }
        }
        if (!error){
            toast.info("File good, ready for upload.");
            setFileValid(true);
        }
    }

    function toggleOnboardingButtons(index, disabled){
        for (let i=0; i < yesIntegrations.length; i++){
            if (i !== index){
                document.getElementById(`onboardDropdown-${index}`).disabled = disabled
            }
        }
    }

    function getOnboardingTemplate(index){
        handleSubmitActions(`onboarding-d-${index}`, `onboarding-load-${index}`);
        toggleOnboardingButtons(index, true);
        let item = yesIntegrations[index];
        console.log("Starting export")
        ApiRequester({reqEndpoint: "int-onboarding", action: "generate_control_id", async: false,
            campus_id: campusId, corporate_id: corporateId,
            client_id: item.external_campus_id, data_type: "all", user_id: dData.user, vendor_id: item.vendor_id}).then(data => {
                console.log(data)
            if (data && !Array.isArray(data) && data?.file_id){
                toast.info("Spreadsheet being created, this may take up to a minute.")
                setOnboardFileId(data.file_id);
                ApiRequester({reqEndpoint: "int-onboarding", action: "create_spreadsheet", async: true,
                    campus_id: campusId, corporate_id: corporateId, file_id: data.file_id,
                    client_id: item.external_campus_id, data_type: "all", user_id: dData.user, vendor_id: item.vendor_id}).then(data => {
                        console.log(data)
                    if (data && !Array.isArray(data)){
                        setOnboardSignCheck(true);
                    }
                    else{
                        formFail(`Error during add, error code: ${data[1]}`, "addNoteSubmit", "loadAddNoteSubmit");
                    }
                });
            }
            else{
                formFail(`Error during generate control id, error code: ${data[1]}`, "addNoteSubmit", "loadAddNoteSubmit");
            }
        });
    }

    function addNoteSubmit(){
        let payload, note;
        handleSubmitActions("addNoteSubmit", "loadAddNoteSubmit");
        note = document.getElementById("note").value;
        payload = [{campus_id: dData.acnt, note: note, modified_by: dData?.user}];
        ApiRequester({reqEndpoint: "mysave", Tbl: "core_campus_notes", Payload: payload, urlType: "PUT",
                            User: dData.user, PKey: "note_id", Condition: "primary", CampusId: campusId,
                            ClientId: dData.sessionId}).then(data => {
            if (data[0] === true){
                setRead(false);
                setNoteIdList([]);
                formSuccess(`Note added successfully.`, "addNoteSubmit", "loadAddNoteSubmit", "cancelAddNoteBtn", "addNoteForm");
                setCount(0);
            }
            else{
                formFail(`Error during add, error code: ${data[1]}`, "addNoteSubmit", "loadAddNoteSubmit");
            }
        });
    }

    function editNoteModal(editIndex){
        let dataIndex, modal;
        if (editRights){
            dataIndex = parseInt(editIndex);
            setNotesStoredIndex(dataIndex);
            document.getElementById("noteE").value = noteData[dataIndex]?.note;
            document.getElementById("noteE").style.height = "125px";
            formCheck("editNoteForm", "editNoteSubmit");
            modal = new Modal(document.getElementById("editnotemodal"), {});
            modal.show();
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function editNoteSubmit(){
        let payload, note, noteId;
        handleSubmitActions("editNoteSubmit", "loadEditNoteSubmit");
        noteId = noteData[notesStoredIndex].note_id
        note = document.getElementById("noteE").value;
        payload = [{note_id: noteId, campus_id: dData.acnt, note: note, modified_by: dData?.user}];
        ApiRequester({reqEndpoint: "mysave", Tbl: "core_campus_notes", Payload: payload, urlType: "POST",
                            User: dData.user, PKey: "note_id", Condition: "primary", CampusId: campusId,
                            ClientId: dData.sessionId}).then(data => {
            if (data[0] === true){
                setRead(false);
                setNoteIdList([]);
                formSuccess(`Note updated successfully.`, "editNoteSubmit", "loadEditNoteSubmit", "cancelEditNoteBtn", "editNoteForm");
                setCount(0);
            }
            else{
                formFail(`Error during add, error code: ${data[1]}`, "addNoteSubmit", "loadAddNoteSubmit");
            }
        });
    }

    function deleteNotesPerform(submitBtn, loadBtn, closeId, start, end){
        let payload;
        if (editRights){
            handleSubmitActions(submitBtn, loadBtn);
            payload = [];
            for (let i=0; i < noteDContent.length; i++){
                payload.push({note_id: noteDContent[i][0], modified_by: dData.user});
            }
            ApiRequester({reqEndpoint: "mysave", Tbl: "core_campus_notes", Payload: payload, urlType: "DELETE",
                                PKey: "note_id", User: dData.user, Condition: "primary", CampusId: campusId}).then(data => {
                if (data[0]){
                    setRead(false);
                    setCount(0);
                    setNoteIdList([]);
                    formSuccess("Notes deleted.", submitBtn, loadBtn, closeId);
                    document.getElementById("uCheckHead6").checked = false;
                    checkAll(start, end);
                    actionAppearance(start, end, ["noteDeleteBtn"]);
                }
                else{
                    formFail(`Error during delete, error code: ${data[1]}`, submitBtn, loadBtn);
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function addIntegrationModal(auth_type_id, index){
        setNIntIndex(parseInt(index))
        let item = noIntegrations[index];
        document.getElementById("int-com-id").value = "";
        document.getElementById("int-credential").value = "";
        document.getElementById("int-auth").value = "";
        
        let receivingCheckbox = document.getElementById("int-receiving");
        let sendingCheckbox = document.getElementById("int-sending");
        let receivingDiv = document.getElementById("int-receiving-div");
        let sendingDiv = document.getElementById("int-sending-div");
        
        if (item.force_feature === 1 || item.force_feature === true){
            // Show checkboxes but lock them
            receivingDiv.classList.remove("d-none");
            sendingDiv.classList.remove("d-none");
            receivingCheckbox.checked = item.feature_receive === 1 || item.feature_receive === true;
            sendingCheckbox.checked = item.feature_send === 1 || item.feature_send === true;
            receivingCheckbox.disabled = true;
            sendingCheckbox.disabled = true;
        }else{
            // Enable checkboxes and show/hide based on feature flags
            receivingCheckbox.disabled = false;
            sendingCheckbox.disabled = false;
            
            if (item.feature_receive === 1 || item.feature_receive === true){
                receivingCheckbox.checked = true;
                receivingDiv.classList.remove("d-none");
            }else{
                receivingCheckbox.checked = false;
                receivingDiv.classList.add("d-none");
            }
            
            if (item.feature_send === 1 || item.feature_send === true){
                sendingCheckbox.checked = true;
                sendingDiv.classList.remove("d-none");
            }else{
                sendingCheckbox.checked = false;
                sendingDiv.classList.add("d-none");
            }
        }
        if ([1,2].includes(auth_type_id)){
            document.getElementById("int-com-id").required = true;
            document.getElementById("int-credential").required = true;
            document.getElementById("int-auth").required = true;
            document.getElementById("int-com-id-div").classList.remove("d-none");
            document.getElementById("int-credential-div").classList.remove("d-none");
            document.getElementById("int-auth-div").classList.remove("d-none");
        }else if (auth_type_id === 4){
            document.getElementById("int-credential").required = false;
            document.getElementById("int-auth").required = true;
            document.getElementById("int-com-id").required = true;
            document.getElementById("int-com-id-div").classList.remove("d-none");
            document.getElementById("int-credential-div").classList.add("d-none");
            document.getElementById("int-auth-div").classList.remove("d-none");
        }
        document.getElementById("integrationDeleteSubmit").classList.add("d-none");
        setOutputOp("Add");
        formCheck("integrationForm", "integrationSubmit");
        showModal("integrationmodal");
    }

    function editIntegrationModal(editIndex){
        let intIndex = parseInt(editIndex);
        setYIntIndex(intIndex);
        let item = yesIntegrations[intIndex];
        let auth_type_id = item.vendor_auth_type_id;
        
        if (auth_type_id === 1){
            document.getElementById("int-com-id").required = true;
            document.getElementById("int-credential").required = true;
            document.getElementById("int-auth").required = true;
            document.getElementById("int-com-id-div").classList.remove("d-none");
            document.getElementById("int-credential-div").classList.remove("d-none");
            document.getElementById("int-auth-div").classList.remove("d-none");
        }else if (auth_type_id === 2){
            document.getElementById("int-credential").required = false;
            document.getElementById("int-auth").required = true;
            document.getElementById("int-com-id").required = true;
            document.getElementById("int-com-id-div").classList.remove("d-none");
            document.getElementById("int-credential-div").classList.add("d-none");
            document.getElementById("int-auth-div").classList.remove("d-none");
        }
        document.getElementById("int-com-id").value = item.external_campus_id;
        document.getElementById("int-credential").value = item.credentials;
        document.getElementById("int-auth").value = item.auth;
        
        let receivingCheckbox = document.getElementById("int-receiving");
        let sendingCheckbox = document.getElementById("int-sending");
        let receivingDiv = document.getElementById("int-receiving-div");
        let sendingDiv = document.getElementById("int-sending-div");
        
        // Handle checkboxes based on force_feature
        if (item.force_feature === 1 || item.force_feature === true){
            // Show checkboxes but lock them
            receivingDiv.classList.remove("d-none");
            sendingDiv.classList.remove("d-none");
            receivingCheckbox.checked = item.feature_receive === 1 || item.feature_receive === true;
            sendingCheckbox.checked = item.feature_send === 1 || item.feature_send === true;
            receivingCheckbox.disabled = true;
            sendingCheckbox.disabled = true;
        }else{
            // Enable checkboxes and show/hide based on feature flags
            receivingCheckbox.disabled = false;
            sendingCheckbox.disabled = false;
            
            if (item.feature_receive === 1 || item.feature_receive === true){
                receivingCheckbox.checked = !!item.is_receiving;
                receivingDiv.classList.remove("d-none");
            }else{
                receivingCheckbox.checked = false;
                receivingDiv.classList.add("d-none");
            }
            
            if (item.feature_send === 1 || item.feature_send === true){
                sendingCheckbox.checked = !!item.is_sending;
                sendingDiv.classList.remove("d-none");
            }else{
                sendingCheckbox.checked = false;
                sendingDiv.classList.add("d-none");
            }
        }
        
        if (!item.is_active){
            document.getElementById("integrationDeleteSubmit").classList.remove("d-none")
        }else{
            document.getElementById("integrationDeleteSubmit").classList.add("d-none")
        }
        setOutputOp("Edit");
        formCheck("integrationForm", "integrationSubmit");
        showModal("integrationmodal");
    }

    function addIntegrationSubmit(){
        let payload;
        let item = noIntegrations[nIntIndex];
        handleSubmitActions("integrationSubmit", "loadIntegrationSubmit");
        
        // If force_feature is true, use the original values from the item
        // Otherwise, read from the checkboxes
        let isSending, isReceiving;
        if (item.force_feature === 1 || item.force_feature === true){
            isSending = item.feature_send === 1 || item.feature_send === true;
            isReceiving = item.feature_receive === 1 || item.feature_receive === true;
        }else{
            isSending = document.getElementById("int-sending").checked;
            isReceiving = document.getElementById("int-receiving").checked;
        }
        
        payload = [{
            vendor_id: item.vendor_id,
            credentials: document.getElementById("int-credential").value,
            vendor_auth_type_id: item.vendor_auth_type_id,
            auth: document.getElementById("int-auth").value,
            external_campus_id: document.getElementById("int-com-id").value,
            is_sending: isSending,
            is_receiving: isReceiving,
            campus_id: campusId
        }];
        ApiRequester({reqEndpoint: "mytransaction", TransType: "add_integration", Payload: payload, OldPayload: [],
                                CampusId: dData.acnt, User: dData.user, ClientId: dData.sessionId}).then(data => {
            if (data[0] === true){
                setRead(false);
                formSuccess(`Integration setup successful.`, "integrationSubmit", "loadIntegrationSubmit", "cancelIntegrationBtn", "integrationForm");
                setCount(0);
            }
            else{
                formFail(`Error during add, error code: ${data[1]}`, "integrationSubmit", "loadIntegrationSubmit");
            }
        });
    }

    function editIntegrationSubmit(){
        let payload, oldPayload;
        let item = yesIntegrations[yIntIndex];
        handleSubmitActions("integrationSubmit", "loadIntegrationSubmit");
        
        // If force_feature is true, use the original values from the item
        // Otherwise, read from the checkboxes
        let isSending, isReceiving;
        if (item.force_feature === 1 || item.force_feature === true){
            isSending = item.feature_send === 1 || item.feature_send === true;
            isReceiving = item.feature_receive === 1 || item.feature_receive === true;
        }else{
            isSending = document.getElementById("int-sending").checked;
            isReceiving = document.getElementById("int-receiving").checked;
        }
        
        payload = [{
            map_id: item.map_id,
            vendor_auth_id: item.vendor_auth_id,
            campus_id: campusId,
            vendor_auth_type_id: item.vendor_auth_type_id,
            credentials: document.getElementById("int-credential").value,
            auth: document.getElementById("int-auth").value,
            external_campus_id: document.getElementById("int-com-id").value,
            is_sending: isSending,
            is_incomming: isReceiving
        }];
        oldPayload = [{
            vendor_auth_id: yesIntegrations[yIntIndex].vendor_auth_id,
            credentials: yesIntegrations[yIntIndex].credentials,
            auth: yesIntegrations[yIntIndex].auth,
            external_campus_id: yesIntegrations[yIntIndex].external_campus_id,
            is_sending: yesIntegrations[yIntIndex].is_sending,
            is_incomming: yesIntegrations[yIntIndex].is_incomming,
        }]
        ApiRequester({reqEndpoint: "mytransaction", TransType: "edit_integration", Payload: payload, OldPayload: oldPayload,
                                CampusId: dData.acnt, User: dData.user, ClientId: dData.sessionId}).then(data => {
            if (data[0] === true){
                setRead(false);
                formSuccess(`Integration update successful.`, "integrationSubmit", "loadIntegrationSubmit", "cancelIntegrationBtn", "integrationForm");
                setCount(0);
            }
            else{
                formFail(`Error during update, error code: ${data[1]}`, "integrationSubmit", "loadIntegrationSubmit");
            }
        });
    }

    function enableIntegration(){
        let payload, oldPayload;
        handleSubmitActions("enableIntSubmit", "loadEnableIntSubmit");
        payload = [{
            map_id: yesIntegrations[yIntIndex].map_id, vendor_auth_id: yesIntegrations[yIntIndex].vendor_auth_id,
            is_active: true, modified_by: dData.user, campus_id: campusId
        }];
        oldPayload = [{
            map_id: yesIntegrations[yIntIndex].map_id, vendor_auth_id: yesIntegrations[yIntIndex].vendor_auth_id,
            is_active: false, campus_id: campusId
        }];
        ApiRequester({reqEndpoint: "mytransaction", TransType: "toggle_integration", Payload: payload, OldPayload: oldPayload,
                            CampusId: dData.acnt, User: dData.user, ClientId: dData.sessionId}).then(data => {
            if (data[0]){
                setRead(false);
                setCount(0);
                formSuccess("Integration disabled.", "enableIntSubmit", "loadEnableIntSubmit", "cancelEnableIntBtn");
                if (dData?.corp === corporateId){
                    reloadSessionCampusItems(campusId, ["ehr_active"], [true], true);
                }
            }
            else{
                formFail(`Error during update, error code: ${data[1]}`, "enableIntSubmit", "loadEnableIntSubmit");
            }
        });
    }

    function disableIntegration(){
        let payload, oldPayload;
        handleSubmitActions("disableIntSubmit", "loadDisableIntSubmit");
        payload = [{
            map_id: yesIntegrations[yIntIndex].map_id, vendor_auth_id: yesIntegrations[yIntIndex].vendor_auth_id,
            is_active: false, modified_by: dData.user, campus_id: campusId
        }];
        oldPayload = [{
            map_id: yesIntegrations[yIntIndex].map_id, vendor_auth_id: yesIntegrations[yIntIndex].vendor_auth_id,
            is_active: true, campus_id: campusId
        }];
        ApiRequester({reqEndpoint: "mytransaction", TransType: "toggle_integration", Payload: payload, OldPayload: oldPayload,
                            CampusId: dData.acnt, User: dData.user, ClientId: dData.sessionId}).then(data => {
            if (data[0]){
                setRead(false);
                setCount(0);
                formSuccess("Integration disabled.", "disableIntSubmit", "loadDisableIntSubmit", "cancelDisableIntBtn");
                if (dData?.corp === corporateId){
                    reloadSessionCampusItems(campusId, ["ehr_active"], [false], true);
                }
            }
            else{
                formFail(`Error during update, error code: ${data[1]}`, "disableIntSubmit", "loadDisableIntSubmit");
            }
        });
    }

    function integrationDeletePerform(){
        let payload;
        handleSubmitActions("deleteIntSubmit", "loadDeleteIntSubmit");
        payload = [{
            vendor_auth_id: yesIntegrations[yIntIndex].vendor_auth_id,
            vendor_auth_type_id: yesIntegrations[yIntIndex].vendor_auth_type_id,
            map_id: yesIntegrations[yIntIndex].map_id,
            campus_id: campusId
        }];
        ApiRequester({reqEndpoint: "mytransaction", TransType: "delete_integration", Payload: payload, OldPayload: [],
                                CampusId: dData.acnt, User: dData.user, ClientId: dData.sessionId}).then(data => {
            if (data[0] === true){
                setRead(false);
                formSuccess(`Integration deleted successfully.`, "deleteIntSubmit", "loadDeleteIntSubmit", "deleteIntConfirmClose");
                setCount(0);
            }
            else{
                formFail(`Error during delete, error code: ${data[1]}`, "deleteIntSubmit", "loadDeleteIntSubmit");
            }
        });
    }

    const userHeaders = (<TableHeaders checkbox={addRights} headerData={userHeaderData}
                                       checkAll={() => checkAll(ppRules.start, ppRules.end, userIdList, setUserIdList, "uCheckHead", "uCheckUser")}
                                       writeAccess={addRights} sortOrder={sorter.sortOrder}
                                       sortColumn={sorter.sortColumn} sorter={sorter} setSorter={setSorter}
                                       modal={false} checkboxlist={userIdList}
                                       actionAppearance={() => actionAppearance(ppRules.start, ppRules.end, ["migrateBtn"], "uCheckUser")} />);

    const groupHeaders = (<TableHeaders checkbox={addRights} headerData={groupHeaderData} checkboxHeaderId={"uCheckHead2"}
                                        checkAll={() => checkAll(groupPPRules.start, groupPPRules.end, groupIdList, setGroupIdList, "uCheckHead2", "uCheckGroup")}
                                        writeAccess={addRights} sortOrder={groupSorter.sortOrder}
                                        sortColumn={groupSorter.sortColumn} sorter={groupSorter} setSorter={setGroupSorter}
                                        modal={false} checkboxlist={groupIdList}
                                        actionAppearance={() => actionAppearance(groupPPRules.start, groupPPRules.end, ["migrateGroupBtn"], "uCheckGroup")} />);
    const afrHeaders = (<TableHeaders checkbox={addRights} headerData={afrHeaderData} checkboxHeaderId={"uCheckHead3"}
                                      checkAll={() => checkAll(0, afrDataSet.length, afrIdList, setAFRIdList, "uCheckHead3", "uCheckAFR")}
                                      writeAccess={addRights} sortOrder={afrSorter.sortOrder}
                                      sortColumn={afrSorter.sortColumn} sorter={afrSorter} setSorter={setAFRSorter}
                                      modal={false} checkboxlist={afrIdList}
                                      actionAppearance={() => actionAppearance(0, afrDataSet.length, ["migrateAFRBtn"], "uCheckAFR")} />);
    const hpHeaders = (<TableHeaders checkbox={addRights} headerData={hpHeaderData} checkboxHeaderId={"uCheckHead4"}
                                     checkAll={() => checkAll(0, hpDataSet.length, hpIdList, setHPIdList, "uCheckHead4", "uCheckHP")}
                                     writeAccess={addRights} sortOrder={hpSorter.sortOrder}
                                     sortColumn={hpSorter.sortColumn} sorter={hpSorter} setSorter={setHPSorter}
                                     modal={false} checkboxlist={hpIdList}
                                     actionAppearance={() => actionAppearance(0, hpDataSet.length, ["migrateHPBtn"], "uCheckHP")} />);
    const reasonHeaders = (<TableHeaders checkbox={addRights} headerData={reasonHeaderData} checkboxHeaderId={"uCheckHead5"}
                                     checkAll={() => checkAll(0, reasonDataSet.length, reasonIdList, setReasonIdList, "uCheckHead5", "uCheckReason")}
                                     writeAccess={addRights} sortOrder={reasonSorter.sortOrder}
                                     sortColumn={reasonSorter.sortColumn} sorter={reasonSorter} setSorter={setReasonSorter}
                                     modal={false} checkboxlist={reasonIdList}
                                     actionAppearance={() => actionAppearance(0, reasonDataSet.length, ["migrateReasonBtn"], "uCheckReason")} />);

    const noteTableHeaders = (<TableHeaders checkbox={addRights} headerData={noteHeaderData} checkboxHeaderId={"uCheckHead6"}
                                       checkAll={() => checkAll(notesPPRules.start, notesPPRules.end, noteIdList, setNoteIdList, "uCheckHead6", "uCheckNote")}
                                       writeAccess={addRights} sortOrder={noteSorter.sortOrder}
                                       sortColumn={noteSorter.sortColumn} sorter={noteSorter} setSorter={setNoteSorter}
                                       modal={editRights} checkboxlist={noteIdList}
                                       actionAppearance={() => actionAppearance(notesPPRules.start, notesPPRules.end, ["noteDeleteBtn"], "uCheckNote")} />);


    const headerContent = (
        <div className={"d-flex justify-content-between"}>
            <div><Button text={"Upload Masterfile"} type={"button"} class={"btn btn-primary mx-3 mt-1"}
                    onClick={() => {
                        setNewFile("");
                        setNewFileName("");
                        setNewFileExt("");
                        setUploadKey("");
                        showModal("uploadmodal");
                    }} />
                <Link to={`/logs/campus/${campusId}`}>
                    <Button text={"View Audit Logs"} type={"button"} class={"btn btn-primary mt-1 mx-3"} />
                </Link>
            </div>
            <div>
                {dData.corp.toString() === corporateId.toString()
                    ?   dData.myCorp.toString() === corporateId.toString()
                        ? <></>
                        : <Button text={"Impersonating"} type={"button"} class={"btn btn-success ms-2 mt-1"} icon={true}
                                  iconClass={"fe fe-eye me-2"} disabled={true} />
                    :   <Button text={"Impersonate"} type={"button"} class={"btn btn-primary ms-2 mt-1"}
                                icon={true} iconClass={"fe fe-eye me-2"}
                                onClick={() => {
                                    document.getElementById("userrole").value = dData.my_role_weight;
                                    showModal("impersonatemodal");
                                }} />
                }
            </div>
        </div>
    );

    return (
        <>
            <Navigation />
            <div className={"main-content"}>
                <Header preTitle={"Campus Profile"} Title={campusName} content={headerContent}/>
                <div className={"container-fluid"}>
                    <div className={"col"}>
                        <ul className={"nav nav-tabs nav-overflow header-tabs"}>
                            <li key={"set-basic"} className={"nav-item"}>
                                <Button text={"Basic Info"}
                                        class={tabItem === "basic" ? "nav-link active" : "nav-link"}
                                        onClick={() => setTabItem("basic")}/>
                            </li>
                            <li key={"set-settings"} className={"nav-item"}>
                                <Button text={"Settings"}
                                        class={tabItem === "settings" ? "nav-link active" : "nav-link"}
                                        onClick={() => setTabItem("settings")}/>
                            </li>
                            <li key={"set-integrations"} className={"nav-item"}>
                                <Button text={"Integrations"}
                                        class={tabItem === "integrations" ? "nav-link active" : "nav-link"}
                                        onClick={() => setTabItem("integrations")}/>
                            </li>
                            <li key={"set-notes"} className={"nav-item"}>
                                <Button text={"Notes"}
                                        class={tabItem === "notes" ? "nav-link active" : "nav-link"}
                                        onClick={() => setTabItem("notes")}/>
                            </li>
                            <li key={"set-server"} className={"nav-item"}>
                                <Button text={"Server Info"}
                                        class={tabItem === "server" ? "nav-link active" : "nav-link"}
                                        onClick={() => setTabItem("server")}/>
                            </li>
                            <li key={"set-migrate"} className={"nav-item"}>
                                <Button text={"Migrating"}
                                        class={tabItem === "migrate" ? "nav-link active" : "nav-link"}
                                        onClick={() => setTabItem("migrate")}/>
                            </li>
                            <li key={"set-geofence"} className={"nav-item"}>
                                <Button text={"Geofence"}
                                        class={tabItem === "geofence" ? "nav-link active" : "nav-link"}
                                        onClick={() => setTabItem("geofence")}/>
                            </li>
                            <li key={"set-designer"} className={"nav-item"}>
                                <Button text={"Zone Designer"}
                                        class={tabItem === "designer" ? "nav-link active" : "nav-link"}
                                        onClick={() => setTabItem("designer")}/>
                            </li>
                        </ul>
                    </div>
                    <div className={tabItem === "init" ? "d-block" : "d-none"}>
                        <p>System settings loading. . .</p>
                    </div>
                    <div className={tabItem === "basic" ? "d-block" : "d-none"}>
                        <div className={"card"} style={{minWidth: "550px"}}>
                            <div className={"card-header d-flex justify-content-between"}>
                                <div>
                                    <h3 className={"card-header-title d-inline-block"}>Basic Information</h3>
                                </div>
                                <div>
                                    <i className={"fe fe-minus as-btn collapse-toggle p-2"} id={"basic-card-btn"}
                                       onClick={() => toggleCollapse("basic-card-btn", "basic-card")}></i>
                                </div>
                            </div>
                            <div className={"card-body collapse collapse-content show"} id={"basic-card"}>
                                <form className={"d-inline align-top form-control-plaintext was-validated"}
                                      id={"basic-form"} autoComplete={"off"} aria-autocomplete={"none"}>
                                    <div className={"mx-5 mt-2 align-top d-inline-block"} id={"basic-col1-div"}>
                                        <div className={"d-flex"}>
                                            <p className={"mb-1"} style={{minWidth: "125px"}}>Id:</p>
                                            <p className={"ms-4 mb-1"} id={"id-static"}>{campusId}</p>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Guid:</p>
                                            <p className={"ms-4"} id={"guid-static"}>{campusGuid}</p>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Name:</p>
                                            <p className={"ms-4"} id={"name-static"}>{campusName}</p>
                                            <input className={"ms-4 d-none form-control form-control-sm"}
                                                   required={true}
                                                   onKeyUp={() => formCheck("basic-form", "save-basic-btn")}
                                                   style={{height: "30px", width: "225px"}} id={"name-edit"}
                                                   defaultValue={campusName} pattern={"^[0-9a-zA-Z_\\- .]+$"}/>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Corporation:</p>
                                            <Link to={`/profiles/corporate/${corporateId}`}>
                                                <p className={"ms-4"} id={"corporate-static"}>{corporateName}</p>
                                            </Link>
                                            <select className={"ms-4 d-none form-select form-select-sm mb-1"}
                                                    onChange={() => {
                                                        formCheck("basic-form", "save-basic-btn");
                                                    }}
                                                    style={{height: "30px", width: "225px"}} id={"corporate-edit"}
                                                    defaultValue={corporateId}>
                                                {corporateOptions}
                                            </select>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p className={"mb-1"} style={{minWidth: "125px"}}>Street Address:</p>
                                            <p className={"ms-4 mb-1"} id={"street-static"}>{streetAddr}</p>
                                            <input className={"ms-4 d-none form-control form-control-sm mb-1"}
                                                   style={{height: "30px", width: "225px"}} id={"street-edit"}
                                                   onKeyUp={() => formCheck("basic-form", "save-basic-btn")}
                                                   defaultValue={streetAddr} pattern={"^[0-9a-zA-Z_\\- ]+$"}/>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p className={"mb-1"} style={{minWidth: "125px"}}>Country:</p>
                                            <p className={"ms-4 mb-1"} id={"country-static"}>{country}</p>
                                            <select className={"ms-4 d-none form-select form-select-sm mb-1"}
                                                    onChange={(e) => {
                                                        formCheck("basic-form", "save-basic-btn");
                                                        setCountryOptionsFunction(e?.target?.value?.toString());
                                                    }}
                                                    style={{height: "30px", width: "225px"}} id={"country-edit"}
                                                    defaultValue={country}>
                                                {countryOptions}
                                            </select>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p className={"mb-1"} style={{minWidth: "125px"}}>State:</p>
                                            <p className={"ms-4 mb-1"} id={"state-static"}>{state}</p>
                                            <select className={"ms-4 d-none form-select form-select-sm mb-1"}
                                                    onChange={() => formCheck("basic-form", "save-basic-btn")}
                                                    style={{height: "30px", width: "225px"}} id={"state-edit"}
                                                    defaultValue={state}>
                                                {stateOptions}
                                            </select>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p className={"mb-1"} style={{minWidth: "125px"}}>City:</p>
                                            <p className={"ms-4 mb-1"} id={"city-static"}>{city}</p>
                                            <input className={"ms-4 d-none form-control form-control-sm mb-1"}
                                                   style={{height: "30px", width: "225px"}} id={"city-edit"}
                                                   onKeyUp={() => formCheck("basic-form", "save-basic-btn")}
                                                   defaultValue={city} pattern={"^[0-9a-zA-Z_\\- ]+$"}/>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Zip Code:</p>
                                            <p className={"ms-4"} id={"zipcode-static"}>{zipcode}</p>
                                            <input className={"ms-4 d-none form-control form-control-sm"}
                                                   onKeyUp={() => formCheck("basic-form", "save-basic-btn")}
                                                   style={{height: "30px", width: "225px"}} id={"zipcode-edit"}
                                                   defaultValue={zipcode} pattern={zipReg}/>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Timezone:</p>
                                            <p className={"ms-4"} id={"timezone-static"}>{timezone}</p>
                                            <select className={"ms-4 d-none form-select form-select-sm mb-1"}
                                                    onChange={() => formCheck("basic-form", "save-basic-btn")}
                                                    style={{height: "30px", width: "225px"}} id={"timezone-edit"}
                                                    defaultValue={timezoneId}>
                                                {timezoneOptions}
                                            </select>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Email:</p>
                                            <p className={"ms-4"} id={"email-static"}>{email}</p>
                                            <input className={"ms-4 d-none form-control form-control-sm"}
                                                   style={{height: "30px", width: "225px"}} id={"email-edit"}
                                                   defaultValue={email}
                                                   onKeyUp={() => formCheck("basic-form", "save-basic-btn")}
                                                   pattern={"[A-Za-z0-9._%+\\-]+@[A-Za-z0-9.\\-]+\\.[A-Za-z]{2,}$"}/>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Phone #:</p>
                                            <p className={"ms-4"} id={"phone-static"}>{formatPhone(phone)}</p>
                                            <input className={"ms-4 d-none form-control form-control-sm"}
                                                   style={{height: "30px", width: "225px"}} id={"phone-edit"}
                                                   onKeyUp={() => formCheck("basic-form", "save-basic-btn")}
                                                   defaultValue={phone} pattern={"[0-9]{3}-?[0-9]{3}-?[0-9]{4}"}/>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Lat/Long:</p>
                                            <p className={"ms-4"}
                                               id={"latlong-static"}>{latitude ? latitude : "?"} / {longitude ? longitude : "?"}</p>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Service Plan Date:</p>
                                            <p className={"ms-4"}
                                               id={"service-static"}>{convertIsoToLocal(servicePlan)}</p>
                                        </div>
                                    </div>
                                </form>
                                {pageLoaded && editRights
                                    ?   <>
                                            <Button text={"Edit"} class={"btn btn-primary float-end"} id={"edit-basic-btn"}
                                                    disabled={!editRights} onClick={() => {
                                                if (editRights) {
                                                    basicActionHandling()
                                                }
                                            }}/>
                                            <Button text={"Save"} class={"btn btn-primary float-end me-3 d-none"}
                                                    id={"save-basic-btn"}
                                                    disabled={!editRights} onClick={() => {
                                                if (editRights) {
                                                    basicSubmit()
                                                }
                                            }}/>
                                            <Button type={"button"} class={"btn btn-primary float-end mx-3 d-none"}
                                                    disabled={true}
                                                    spinner={true} text={""} id={"load-basic-btn"}/>
                                        </>
                                    :   <></>
                                }
                            </div>
                        </div>
                    </div>
                    <div className={tabItem === "settings" ? "d-block" : "d-none"}>
                        <div className={"card"} style={{minWidth: "550px"}}>
                            <div className={"card-header d-flex justify-content-between"}>
                                <div>
                                    <h3 className={"card-header-title d-inline-block"}>Campus Settings</h3>
                                </div>
                                <div>
                                    <i className={"fe fe-minus as-btn collapse-toggle p-2"} id={"settings-card-btn"}
                                       onClick={() => toggleCollapse("settings-card-btn", "settings-card")}></i>
                                </div>
                            </div>
                            <div className={"card-body collapse collapse-content show"} id={"settings-card"}>
                                <form className={"d-inline align-top form-control-plaintext was-validated"}
                                      id={"settings-form"}>
                                    <div className={"d-inline-block w-100"}>
                                        <div className={"d-inline-block w-50 border rounded p-4 align-top"}
                                             style={{minWidth: "380px", height: "425px"}}>
                                            <div className={"float-end"}>
                                                <Button text={"Cancel"} id={"p-settings-cancel-btn"}
                                                        class={"btn btn-secondary d-none me-3"}
                                                        onClick={() => {
                                                            setIsHybrid(pSettingsOriginList[0]);
                                                            setShowLegacy(pSettingsOriginList[1]);
                                                            setShowNew(pSettingsOriginList[2]);
                                                            setIsCloud(pSettingsOriginList[3]);
                                                        }}/>
                                                <Button type={"button"} class={"btn btn-primary d-none ms-3"}
                                                        disabled={true}
                                                        spinner={true} text={"Saving"} id={"p-settings-load-btn"}/>
                                                <Button icon={true} iconClass={"fe fe-edit me-2"} text={"Save"}
                                                        id={"p-settings-btn"}
                                                        class={"btn btn-primary d-none"}
                                                        onClick={() => platformSettingSubmit()}/>
                                            </div>
                                            <h2 className={"text-primary mb-4"}>Architecture</h2>
                                            <div id={"settings-2-1"} className={"mb-3"}>
                                                <div className={"form-check form-switch"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"is-hybrid"} checked={isHybrid}
                                                           onChange={(e) => {
                                                               setIsHybrid(e.target.checked);
                                                               if (!e.target.checked) {
                                                                   setShowNew(e.target.checked);
                                                                   setShowLegacy(e.target.checked);
                                                               }
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"is-hybrid"}>
                                                        Hybrid Setup
                                                    </label>
                                                </div>
                                                <p className={"text-muted mb-1"}>
                                                    Setup contains a tap with both 2.0 and 4.0 server connected
                                                </p>
                                                <div className={"ms-3"}>
                                                    <div className={"form-check form-switch"}>
                                                        <input className={"form-check-input"} type={"checkbox"}
                                                               id={"show-new"} checked={showNew}
                                                               disabled={!isHybrid}
                                                               onChange={(e) => {
                                                                   setShowNew(e.target.checked);
                                                               }}/>
                                                        <label className={"form-check-label text-dark"}
                                                               htmlFor={"show-new"}>
                                                            Show 4.0 Alerts
                                                        </label>
                                                    </div>
                                                    <p className={"text-muted mb-1"}>Events from 4.0 server appear in
                                                        Pal Portal</p>
                                                    <div className={"form-check form-switch"}>
                                                        <input className={"form-check-input"} type={"checkbox"}
                                                               id={"show-legacy"} checked={showLegacy}
                                                               disabled={!isHybrid}
                                                               onChange={(e) => {
                                                                   setShowLegacy(e.target.checked);
                                                               }}/>
                                                        <label className={"form-check-label text-dark"}
                                                               htmlFor={"show-legacy"}>
                                                            Show 2.0 Alerts
                                                        </label>
                                                    </div>
                                                    <p className={"text-muted mb-1"}>Events from 2.0 server appear in
                                                        Pal Portal</p>
                                                </div>
                                            </div>
                                            <div id={"settings-2-2"}>
                                                <div className={"form-check form-switch"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"is-cloud"} checked={isCloud}
                                                           onChange={(e) => {
                                                               setIsCloud(e.target.checked);
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"is-cloud"}>
                                                        Upgraded to 5.0
                                                    </label>
                                                </div>
                                                <p className={"text-muted mb-1"}>Uses 5.0 Cloud Platform <strong>(Do Not Use)</strong></p>
                                            </div>
                                        </div>
                                        <div className={"d-inline-block w-50 border rounded p-4 align-top"}
                                             style={{minWidth: "380px", height: "425px"}}>
                                            <div className={"float-end"}>
                                                <Button text={"Cancel"} id={"r-settings-cancel-btn"}
                                                        class={"btn btn-secondary d-none me-3"}
                                                        onClick={() => {
                                                            setIsEventNotes(rSettingsOriginList[0]);
                                                            setIsNotesFreeform(rSettingsOriginList[1]);
                                                            setIsNotesPreform(rSettingsOriginList[2]);
                                                            setIsReasonEditable(rSettingsOriginList[3]);
                                                            setIsResidentTrends(rSettingsOriginList[4]);
                                                        }}/>
                                                <Button type={"button"} class={"btn btn-primary d-none ms-3"}
                                                        disabled={true}
                                                        spinner={true} text={"Saving"} id={"r-settings-load-btn"}/>
                                                <Button icon={true} iconClass={"fe fe-edit me-2"} text={"Save"}
                                                        id={"r-settings-btn"}
                                                        class={"btn btn-primary d-none"}
                                                        onClick={() => reportSettingsSubmit()}/>
                                            </div>
                                            <h2 className={"text-primary mb-4"}>Event Reporting</h2>
                                            <div id={"settings-1-1"} className={"mb-3"}>
                                                <div className={"form-check form-switch"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"notes-active"} checked={isEventNotes}
                                                           onChange={(e) => {
                                                               setIsEventNotes(e.target.checked);
                                                               if (!e.target.checked) {
                                                                   setIsNotesFreeform(e.target.checked);
                                                                   setIsNotesPreform(e.target.checked);
                                                               }
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"notes-active"}>
                                                        Event Notes
                                                    </label>
                                                </div>
                                                <p className={"text-muted mb-1"}>Can add notes to report events</p>
                                                <div className={"ms-3"}>
                                                    <div className={"form-check form-switch"}>
                                                        <input className={"form-check-input"} type={"checkbox"}
                                                               id={"notes-freeform"} disabled={!isEventNotes}
                                                               checked={isNotesFreeform}
                                                               onChange={(e) => {
                                                                   setIsNotesFreeform(e.target.checked);
                                                               }}/>
                                                        <label className={"form-check-label text-dark"}
                                                               htmlFor={"notes-freeform"}>
                                                            Allow Freeform Notes
                                                        </label>
                                                    </div>
                                                    <p className={"text-muted mb-1"}>Allows notes to be able to be added
                                                        freeform (default if no option selected)</p>
                                                    <div className={"form-check form-switch"}>
                                                        <input className={"form-check-input"} type={"checkbox"}
                                                               id={"notes-preform"} disabled={!isEventNotes}
                                                               checked={isNotesPreform}
                                                               onChange={(e) => {
                                                                   setIsNotesPreform(e.target.checked);
                                                               }}/>
                                                        <label className={"form-check-label text-dark"}
                                                               htmlFor={"notes-preform"}>
                                                            Use pre-defined note options
                                                        </label>
                                                    </div>
                                                    <p className={"text-muted mb-1"}>Notes are added from predefined
                                                        options.</p>
                                                </div>
                                            </div>
                                            <div id={"settings-1-2"}>
                                                <div className={"form-check form-switch"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"reasons-editable"} checked={isReasonEditable}
                                                           onChange={(e) => {
                                                               setIsReasonEditable(e.target.checked);
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"reasons-editable"}>
                                                        Reason Codes Editable
                                                    </label>
                                                </div>
                                                <p className={"text-muted"}>Can edit reason codes on report events</p>
                                            </div>
                                            <div id={"settings-1-3"}>
                                                <div className={"form-check form-switch"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"resident-trends-editable"} checked={isResidentTrends}
                                                           onChange={(e) => {
                                                               setIsResidentTrends(e.target.checked);
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"resident-trends-editable"}>
                                                        Resident Analysis Trends
                                                    </label>
                                                </div>
                                                <p className={"text-muted"}>Show resident analysis trends on dashboards and resident profiles</p>
                                            </div>
                                        </div>
                                        <div className={"d-inline-block w-50 border rounded p-4 align-top"}
                                             style={{minWidth: "380px", height: "525px"}}>
                                            <div className={"float-end"}>
                                                <Button text={"Cancel"} id={"o-settings-cancel-btn"}
                                                        class={"btn btn-secondary d-none me-3"}
                                                        onClick={() => {
                                                            setIsMobile(oSettingsOriginList[0]);
                                                            setIsText(oSettingsOriginList[1]);
                                                            setIsEmail(oSettingsOriginList[2]);
                                                            setIsPager(oSettingsOriginList[3]);
                                                            setIsVoice(oSettingsOriginList[4]);
                                                            setIsLightController(oSettingsOriginList[5]);
                                                            setIsOffsite(oSettingsOriginList[6]);
                                                        }}/>
                                                <Button type={"button"} class={"btn btn-primary d-none ms-3"}
                                                        disabled={true}
                                                        spinner={true} text={"Saving"} id={"o-settings-load-btn"}/>
                                                <Button icon={true} iconClass={"fe fe-edit me-2"} text={"Save"}
                                                        id={"o-settings-btn"}
                                                        class={"btn btn-primary d-none"}
                                                        onClick={() => outputSettingsSubmit()}/>
                                            </div>
                                            <h2 className={"text-primary mb-4"}>Output Features</h2>
                                            <div id={"settings-3-1"}>
                                                <div className={"form-check form-switch"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"app-active"} checked={isMobile}
                                                           onChange={(e) => {
                                                               setIsMobile(e.target.checked);
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"app-active"}>
                                                        Mobile App
                                                    </label>
                                                </div>
                                                <p className={"text-muted mb-3"}>System using mobile app</p>
                                            </div>
                                            <div id={"settings-3-2"}>
                                                <div className={"form-check form-switch"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"text-active"} checked={isText}
                                                           onChange={(e) => {
                                                               setIsText(e.target.checked);
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"text-active"}>
                                                        Text Messaging
                                                    </label>
                                                </div>
                                                <p className={"text-muted mb-3"}>System using text messaging</p>
                                            </div>
                                            <div id={"settings-3-3"}>
                                                <div className={"form-check form-switch"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"email-active"} checked={isEmail}
                                                           onChange={(e) => {
                                                               setIsEmail(e.target.checked);
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"email-active"}>
                                                        Email
                                                    </label>
                                                </div>
                                                <p className={"text-muted mb-3"}>System using email messaging</p>
                                            </div>
                                            <div id={"settings-3-4"}>
                                                <div className={"form-check form-switch"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"pager-active"} checked={isPager}
                                                           onChange={(e) => {
                                                               setIsPager(e.target.checked);
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"pager-active"}>
                                                        Pagers
                                                    </label>
                                                </div>
                                                <p className={"text-muted mb-3"}>System using paging transmitter</p>
                                            </div>
                                            <div id={"settings-3-5"}>
                                                <div className={"form-check form-switch"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"voice-active"} checked={isVoice}
                                                           onChange={(e) => {
                                                               setIsVoice(e.target.checked);
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"voice-active"}>
                                                        Voice Calls
                                                    </label>
                                                </div>
                                                <p className={"text-muted mb-3"}>System using voice escalation</p>
                                            </div>
                                            <div id={"settings-3-6"}>
                                                <div className={"form-check form-switch"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"lightbox-active"} checked={isLightController}
                                                           onChange={(e) => {
                                                               setIsLightController(e.target.checked);
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"lightbox-active"}>
                                                        Light Controller
                                                    </label>
                                                </div>
                                                <p className={"text-muted mb-3"}>System outputs to light controllers</p>
                                            </div>
                                            <div id={"settings-3-7"}>
                                                <div className={"form-check form-switch"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"offsite-active"} checked={isOffsite}
                                                           onChange={(e) => {
                                                               setIsOffsite(e.target.checked);
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"offsite-active"}>
                                                        Offsite Monitoring
                                                    </label>
                                                </div>
                                                <p className={"text-muted mb-3"}>System outputs to integrated offsite monitoring provider <strong>(Careflow V2 Only)</strong></p>
                                            </div>
                                        </div>
                                        <div className={"d-inline-block w-50 border rounded p-4 align-top"}
                                             style={{minWidth: "380px", height: "525px"}}>
                                            <div className={"float-end"}>
                                                <Button text={"Cancel"} id={"c-settings-cancel-btn"}
                                                        class={"btn btn-secondary d-none me-3"}
                                                        onClick={() => {
                                                            setCareflowV2(cSettingsOriginList[0]);
                                                            setAreaCareflow(cSettingsOriginList[1]);
                                                            setResCareflow(cSettingsOriginList[2]);
                                                            setDevCareflow(cSettingsOriginList[3]);
                                                            setEventCareflow(cSettingsOriginList[4]);
                                                            setCheckin(cSettingsOriginList[5]);
                                                            setRounds(cSettingsOriginList[6]);
                                                        }}/>
                                                <Button type={"button"} class={"btn btn-primary d-none ms-3"}
                                                        disabled={true}
                                                        spinner={true} text={"Saving"} id={"c-settings-load-btn"}/>
                                                <Button icon={true} iconClass={"fe fe-edit me-2"} text={"Save"}
                                                        id={"c-settings-btn"}
                                                        class={"btn btn-primary d-none"}
                                                        onClick={() => careflowSettingsSubmit()}/>
                                            </div>
                                            <h2 className={"text-primary mb-4"}>Wellness Settings</h2>
                                            <div id={"settings-4-1"}>
                                                <div className={"form-check form-switch"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"careflow-new"} checked={careflowV2}
                                                           onChange={(e) => {
                                                               setCareflowV2(e.target.checked);
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"careflow-new"}>
                                                        Using Careflow V2
                                                    </label>
                                                </div>
                                                <p className={"text-muted mb-3"}>Using new version 2 of careflow <strong>(5.0 only)</strong></p>
                                            </div>
                                            <div id={"settings-4-2"}>
                                                <div className={"form-check form-switch"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"careflow-area"} checked={areaCareflow}
                                                           onChange={(e) => {
                                                               setAreaCareflow(e.target.checked);
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"careflow-area"}>
                                                        Using Area Careflows
                                                    </label>
                                                </div>
                                                <p className={"text-muted mb-3"}>Using area group based careflows</p>
                                            </div>
                                            <div id={"settings-4-3"}>
                                                <div className={"form-check form-switch"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"careflow-resident"} checked={resCareflow}
                                                           onChange={(e) => {
                                                               setResCareflow(e.target.checked);
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"careflow-resident"}>
                                                        Using Resident Careflows
                                                    </label>
                                                </div>
                                                <p className={"text-muted mb-3"}>Using resident group based careflows</p>
                                            </div>
                                            <div id={"settings-4-4"}>
                                                <div className={"form-check form-switch"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"careflow-device"} checked={devCareflow}
                                                           onChange={(e) => {
                                                               setDevCareflow(e.target.checked);
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"careflow-device"}>
                                                        Using Device Careflows
                                                    </label>
                                                </div>
                                                <p className={"text-muted mb-3"}>Using device specific careflows</p>
                                            </div>
                                            <div id={"settings-4-5"}>
                                                <div className={"form-check form-switch"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"careflow-event"} checked={eventCareflow}
                                                           onChange={(e) => {
                                                               setEventCareflow(e.target.checked);
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"careflow-event"}>
                                                        Using Event Careflows
                                                    </label>
                                                </div>
                                                <p className={"text-muted mb-3"}>Using event category based careflows</p>
                                            </div>
                                            <div id={"settings-4-6"}>
                                                <div className={"form-check form-switch"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"checkin-on"} checked={checkin}
                                                           onChange={(e) => {
                                                               setCheckin(e.target.checked);
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"careflow-new"}>
                                                        Using Resident Check-in
                                                    </label>
                                                </div>
                                                <p className={"text-muted mb-3"}>Enables resident check-in within wellness settings</p>
                                            </div>
                                            <div id={"settings-4-7"}>
                                                <div className={"form-check form-switch"}>
                                                    <input className={"form-check-input"} type={"checkbox"}
                                                           id={"rounds-on"} checked={rounds}
                                                           onChange={(e) => {
                                                               setRounds(e.target.checked);
                                                           }}/>
                                                    <label className={"form-check-label text-dark"}
                                                           htmlFor={"careflow-new"}>
                                                        Using Rounds
                                                    </label>
                                                </div>
                                                <p className={"text-muted mb-3"}>Enables rounds within wellness settings</p>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className={tabItem === "integrations" ? "d-block" : "d-none"} style={{maxWidth: "1400px"}}>
                        <div className="d-flex align-items-center mb-4">
                            <div className="flex-grow-1">
                                <h2 className="mb-1 fw-bold text-dark">Current Integrations</h2>
                                <p className="text-muted mb-0">Manage your active third-party integrations</p>
                            </div>
                            <div className="badge bg-primary fs-6 px-3 py-2">
                                {yesIntegrations?.length || 0} Active
                            </div>
                        </div>
                        {!yesIntegrations?.length || yesIntegrations.length === 0
                            ?   <div className="text-center py-0">
                                    <div className="mb-3">
                                        <i className="fe fe-link-2" style={{fontSize: "3rem", color: "var(--color-text-secondary)"}}></i>
                                    </div>
                                    <h4 className="text-muted mb-2">No Active Integrations</h4>
                                    <p className="text-muted">Set up integrations below to connect with third-party services</p>
                                </div>
                            :   <></>
                        }
                        {yesIntegrations.map((item, index) => {
                            return (
                                <div className={"card"}>
                                    <div className={"card-body row g-3"}>
                                        <div className={"col-12 col-lg-2 my-auto"} style={{minWidth: "200px"}}>
                                            {item.logo_file
                                                ? item.website_url
                                                    ?   <a href={item.website_url} target={"_blank"} rel={"noreferrer"}>
                                                            <img className={"ms-lg-4"} width={"120px"} height={"36px"}
                                                                 src={imgMap[item.logo_file]} alt={`${item.vendor_name} Logo`} />
                                                        </a>
                                                    :   <img className={"ms-lg-4"} width={"120px"} height={"36px"}
                                                             src={imgMap[item.logo_file]} alt={`${item.vendor_name} Logo`} />
                                                : item.website_url
                                                    ?   <a href={item.website_url} target={"_blank"} rel={"noreferrer"} style={{color: "unset"}}>
                                                            <h3 className={"ms-lg-4 fw-bold mb-0"}>{item.vendor_name}</h3>
                                                        </a>
                                                    :   <h3 className={"ms-lg-4 fw-bold mb-0"}>{item.vendor_name}</h3>
                                            }
                                        </div>
                                        <div className={"col-12 col-lg-4"}>
                                            <div className={"row g-2"}>
                                                <div className={"col-12 col-md-auto mb-2 mb-md-0 me-2"}>
                                                    <Button text={"Edit"} class={"btn btn-outline-primary"}
                                                            onClick={() => editIntegrationModal(index)}/>
                                                </div>
                                                <div className={"col-12 col-md"}>
                                                    <div>
                                                        <span className={"badge bg-light text-dark me-3 px-2 py-1 align-top"}
                                                              style={{fontSize: "var(--font-size-xs)"}}>
                                                            <i className="fe fe-user me-1"></i>Credentials
                                                        </span>
                                                        {item?.credentials ? (
                                                            <span className={"d-inline-flex align-items-center"}>
                                                                <h4 className={"d-inline-block align-top text-break mb-0"}
                                                                    style={{cursor: "pointer"}}
                                                                    onClick={() => {
                                                                        const newSet = new Set(revealedCredentials);
                                                                        const key = item.map_id || index;
                                                                        if (newSet.has(key)) {
                                                                            newSet.delete(key);
                                                                        } else {
                                                                            newSet.add(key);
                                                                        }
                                                                        setRevealedCredentials(newSet);
                                                                    }}>
                                                                    {revealedCredentials.has(item.map_id || index)
                                                                        ? item.credentials
                                                                        : <span className={"text-muted"}>••••••••</span>}
                                                                </h4>
                                                                <i className={`fe ${revealedCredentials.has(item.map_id || index) ? "fe-eye-off" : "fe-eye"} ms-2 as-btn-1x`}
                                                                   onClick={() => {
                                                                       const newSet = new Set(revealedCredentials);
                                                                       const key = item.map_id || index;
                                                                       if (newSet.has(key)) {
                                                                           newSet.delete(key);
                                                                       } else {
                                                                           newSet.add(key);
                                                                       }
                                                                       setRevealedCredentials(newSet);
                                                                   }}
                                                                   title={revealedCredentials.has(item.map_id || index) ? "Hide credentials" : "Show credentials"}></i>
                                                            </span>
                                                        ) : (
                                                            <h4 className={"d-inline-block align-top text-break mb-0"}>N/A</h4>
                                                        )}
                                                    </div>
                                                    <div className={"mt-3"}>
                                                        <span className={"badge bg-light text-dark me-3 px-2 py-1"}
                                                              style={{fontSize: "var(--font-size-xs)"}}>
                                                            <i className={"fe fe-unlock me-1"}></i>Auth Token
                                                        </span>
                                                        {item?.auth ? (
                                                            <span className={"d-inline-flex align-items-center"}>
                                                                <h4 className={"d-inline-block text-break mb-0"}
                                                                    style={{cursor: "pointer"}}
                                                                    onClick={() => {
                                                                        const newSet = new Set(revealedAuthTokens);
                                                                        const key = item.map_id || index;
                                                                        if (newSet.has(key)) {
                                                                            newSet.delete(key);
                                                                        } else {
                                                                            newSet.add(key);
                                                                        }
                                                                        setRevealedAuthTokens(newSet);
                                                                    }}>
                                                                    {revealedAuthTokens.has(item.map_id || index)
                                                                        ? item.auth
                                                                        : <span className={"text-muted"}>••••••••</span>}
                                                                </h4>
                                                                <i className={`fe ${revealedAuthTokens.has(item.map_id || index) ? "fe-eye-off" : "fe-eye"} ms-2 as-btn-1x`}
                                                                   onClick={() => {
                                                                       const newSet = new Set(revealedAuthTokens);
                                                                       const key = item.map_id || index;
                                                                       if (newSet.has(key)) {
                                                                           newSet.delete(key);
                                                                       } else {
                                                                           newSet.add(key);
                                                                       }
                                                                       setRevealedAuthTokens(newSet);
                                                                   }}
                                                                   title={revealedAuthTokens.has(item.map_id || index) ? "Hide auth token" : "Show auth token"}></i>
                                                            </span>
                                                        ) : (
                                                            <h4 className={"d-inline-block text-break mb-0"}>N/A</h4>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={"col-12 col-lg-3"}>
                                            <div className={"row"}>
                                                <div>
                                                    <span className={"badge bg-light text-dark me-2 px-2 py-1 align-top"} style={{fontSize: "var(--font-size-xs)"}}>
                                                        <i className={"fe fe-settings me-1"}></i>Features
                                                    </span>
                                                    <h4 className={"d-inline-block ps-0"} style={{listStyle: "none"}}>
                                                        {item.is_receiving ? "Receiving Data" : ""}
                                                        {item.is_receiving && item.is_sending ? <br/> : <></>}
                                                        {item.is_sending ? "Sending Data" : ""}
                                                    </h4>
                                                </div>
                                                <div className={"mt-3"}>
                                                    <span className={"badge bg-light text-dark me-3 px-2 py-1 align-top"} style={{fontSize: "var(--font-size-xs)"}}>
                                                        <i className={"fe fe-activity me-1"}></i>Status
                                                    </span>
                                                    <span className={`badge ${item.is_active ? 'bg-success' : 'bg-warning'} px-2 py-1 align-top`} style={{fontSize: "var(--font-size-xs)"}}>
                                                        <i className={`fe ${item.is_active ? 'fe-check-circle' : 'fe-clock'} me-1`}></i>
                                                        {item.is_active ? "Live" : "Inactive"}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={"col-12 col-lg-2 d-flex my-auto"}>
                                            {item.is_active
                                                ?   <Button text={"De-activate"} class={"btn btn-danger ms-auto"}
                                                            style={{minWidth: "110px"}}
                                                            id={`active-toggle-${index}`} onClick={() => {
                                                        setYIntIndex(index);
                                                        showModal("confirmdeactivate");
                                                    }} />
                                                :   <>
                                                        <Button type={"button"} class={"btn btn-primary d-none me-3"}
                                                                disabled={true} spinner={true} text={"Loading"}
                                                                id={`onboarding-load-${index}`} />
                                                        <div className={"dropdown d-inline me-3"} id={`onboarding-d-${index}`}>
                                                            <button type={"button"} className={"btn btn-primary dropdown-toggle px-4 pt-2 fs-4"}
                                                                    data-bs-toggle={"dropdown"} id={`onboardDropdown-${index}`} data-bs-auto-close={"true"}
                                                                    style={{ height: "46px" }} aria-expanded={"false"}>
                                                                <i className={"fe fe-download me-2"}/>Template
                                                            </button>
                                                            <div className={"dropdown-menu dropdown-menu-end"} aria-labelledby={`onboardDropdown-${index}`}>
                                                                <Button text={"Template Download"} class={"dropdown-item"}
                                                                        title={"Will create and download onboarding template with integration data"}
                                                                        id={`onboarding-fetch-${index}`} onClick={() => {
                                                                    getOnboardingTemplate(index)
                                                                }} />
                                                                <Button text={"Template Upload"} class={"dropdown-item"}
                                                                        title={"Will create and download onboarding template with integration data"}
                                                                        id={`onboarding-send-${index}`} onClick={() => {
                                                                            setOnboardIndex(index);
                                                                            showModal("onboardmodal")
                                                                }} />
                                                            </div>
                                                        </div>
                                                        <Button text={"Activate"} class={"btn btn-success ms-auto"}
                                                                style={{minWidth: "110px"}}
                                                                id={`active-toggle-${index}`} onClick={() => {
                                                            setYIntIndex(index);
                                                            showModal("confirmactivate");
                                                        }} />
                                                    </>
                                            }
                                        </div>
                                    </div>
                                </div>
                            )})}
                        <hr/>
                        <div className="d-flex align-items-center mb-4">
                            <div className="flex-grow-1">
                                <h2 className="mb-1 fw-bold text-dark">Available Integrations</h2>
                                <p className="text-muted mb-0">Connect with additional third-party services</p>
                            </div>
                            <div className="badge bg-secondary fs-6 px-3 py-2">
                                {noIntegrations?.length || 0} Available
                            </div>
                        </div>
                        {!noIntegrations?.length || noIntegrations.length === 0
                            ?   <div className="text-center py-5">
                                    <div className="mb-3">
                                        <i className="fe fe-plus-circle" style={{fontSize: "3rem", color: "var(--color-text-secondary)"}}></i>
                                    </div>
                                    <h4 className="text-muted mb-2">No Available Integrations</h4>
                                    <p className="text-muted">Check back later for new integration options</p>
                                </div>
                            :   <></>
                        }
                        {noIntegrations.map((item, index) => {
                            return (
                                <div className={"card"}>
                                    <div className={"card-body row g-3"}>
                                        <div className={"col-12 col-lg-2 my-auto"} style={{minWidth: "200px"}}>
                                            {item.logo_file
                                                ? item.website_url
                                                    ?   <a href={item.website_url} target={"_blank"} rel={"noreferrer"}>
                                                            <img className={"ms-lg-4"} width={"120px"} height={"36px"}
                                                                 src={imgMap[item.logo_file]} alt={`${item.vendor_name} Logo`} />
                                                        </a>
                                                    :   <img className={"ms-lg-4"} width={"120px"} height={"36px"}
                                                             src={imgMap[item.logo_file]} alt={`${item.vendor_name} Logo`} />
                                                : item.website_url
                                                    ?   <a href={item.website_url} target={"_blank"} rel={"noreferrer"} style={{color: "unset"}}>
                                                            <h3 className={"ms-lg-4 fw-bold mb-0"}>{item.vendor_name}</h3>
                                                        </a>
                                                    :   <h3 className={"ms-lg-4 fw-bold mb-0"}>{item.vendor_name}</h3>
                                            }
                                        </div>
                                        <div className={"col-12 col-lg-4"}>
                                            <div className={"row"}>
                                                <div className={"col-12"}>
                                                    <span className="badge bg-light text-dark me-2 px-2 py-1"
                                                          style={{fontSize: "var(--font-size-xs)"}}>
                                                        <i className="fe fe-code me-1"></i>API Method
                                                    </span>
                                                    <h4 className={`d-inline-block`}>
                                                        {item?.auth_type_name ? item?.auth_type_name : "Unknown"}
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={"col-12 col-lg-3"}>
                                            <div>
                                                <span className="badge bg-light text-dark me-2 px-2 py-1 align-top"
                                                      style={{fontSize: "var(--font-size-xs)"}}>
                                                    <i className="fe fe-zap me-1"></i>Features
                                                </span>
                                                <h4 className={"d-inline-block"}>
                                                    {item.feature_receive ? "Receiving Data" : ""}
                                                    {item.feature_receive && item.feature_send ? <br/> : <></>}
                                                    {item.feature_send ? "Sending Data" : ""}
                                                </h4>
                                            </div>
                                        </div>
                                        <div className={"col-12 col-lg-2 d-flex my-auto"}>
                                            {item.is_active
                                                ?   <Button text={"Set-up"} class={"btn btn-primary ms-auto"}
                                                            style={{minWidth: "110px"}}
                                                            id={`inactive-toggle-${index}`} onClick={() => {
                                                        addIntegrationModal(item.vendor_auth_type_id, index);
                                                    }} />
                                                :   <Button text={"Unavailable"} class={"btn btn-secondary ms-auto"}
                                                            disabled={true} style={{minWidth: "110px"}}
                                                            id={`inactive-toggle-${index}`} onClick={() => {

                                                    }} />
                                            }
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div className={tabItem === "notes" ? "d-block" : "d-none"}>
                        <div className={"card"}>
                            <div className={"card-body collapse collapse-content show"} id={"notes-card"}>
                                <div className={"d-flex justify-content-between pb-3"}>
                                    <div>

                                    </div>
                                    <div>
                                        {editRights
                                            ?   <Button text={"Delete"} type={"button"}
                                                       class={"btn btn-danger me-2 hide"}
                                                       id={"noteDeleteBtn"} icon={true}
                                                       iconClass={"fe fe-trash-2 me-2"}
                                                       onClick={() => callActionModal(notesPPRules.start, notesPPRules.end, noteData,
                                                           ["note_id", "display_name"], ["note_id", ""], "",
                                                           setNoteDContent, "deletenotesmodal", "deleteBulkModalContent",
                                                           "Are you sure you wish to delete the following records? ", "uCheckNote")}/>
                                            :   <></>
                                        }
                                        {noteCSVButton}
                                        {addRights
                                            ?   <Button text={"Add Note"} type={"button"}
                                                      class={"btn btn-primary ms-2 mt-1"}
                                                      icon={true} iconClass={"fe fe-plus me-2"}
                                                      onClick={() => {
                                                          document.getElementById("note").value = "";
                                                          document.getElementById("note").style.height = "125px";
                                                          formCheck("addNoteForm", "addNoteSubmit");
                                                          showModal("addnotemodal");
                                                      }}/>
                                            :   <></>
                                        }
                                    </div>
                                </div>
                                <table className={"table table-sm table-white table-hover"}>
                                    <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                    {noteTableHeaders}
                                    </thead>
                                    <tbody id={"tBody"}>
                                    {noteTableRows}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className={tabItem === "server" ? "d-block" : "d-none"}>
                        <div className={"card"} style={{minWidth: "500px"}}>
                            <div className={"card-header d-flex justify-content-between"}>
                                <div>
                                    <h3 className={"card-header-title d-inline-block"} style={{minWidth: "80px"}}>Server
                                        Status's</h3>
                                    <div className={"d-inline"} style={{display: "inline-block"}} id={"db-header-data"}>
                                        <h3 className={"ms-6 my-0 d-inline-block text-success"}></h3>
                                    </div>
                                </div>
                                <div>
                                    <i className={"fe fe-minus as-btn collapse-toggle p-2"} id={"devices-card-btn"}
                                       onClick={() => {
                                           toggleCollapse("db-card-btn", "db-card");
                                           document.getElementById("db-header-data").classList.toggle("d-none");
                                       }}></i>
                                </div>
                            </div>
                            <div className={"card-body collapse collapse-content show"} id={"db-card"}>
                                <table className={"table table-sm table-responsive-sm table-hover"}>
                                    <thead className={"table-header"}>
                                    <tr>
                                        <td className={"text-center"}>Server</td>
                                        <td className={"text-center"}>Process Count</td>
                                        <td className={"text-center"}>Aggregate Count</td>
                                        <td className={"text-center"}>Eman Count</td>
                                        <td className={"text-center"}>Maint. Count</td>
                                        <td className={"text-center"}>Other Count</td>
                                        <td className={"text-center"}>Alarm Time</td>
                                        <td className={"text-center"}>Alarm Parsed</td>
                                        <td className={"text-center"}>Last Updated</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {deviceData.map((device, index) => {
                                        if (corporateId.toString() === dData.corp.toString()) {
                                            return (<tr key={`device-item-${index}`}>
                                                <td><Link
                                                    to={`/community/server_devices/${device?.palcare_device_id}`}>{device?.description}</Link>
                                                </td>
                                                <td className={"text-center"}>{device?.count_process_queue}</td>
                                                <td className={"text-center"}>{device?.count_aggregate_repeater_queue}</td>
                                                <td className={"text-center"}>{device?.count_eman_event_queue}</td>
                                                <td className={"text-center"}>{device?.count_maint_queue}</td>
                                                <td className={"text-center"}>{device?.count_other_queue}</td>
                                                <td className={"text-center"}>{device?.recent_alarm_input_time}</td>
                                                <td className={"text-center"}>
                                                    <MaterialIcon className={"material-icons as-btn-2x me-2"}
                                                                  onClick={() => {
                                                                      toast.info(device?.recent_alarm_input_raw);
                                                                      navigator?.clipboard?.writeText(device?.recent_alarm_input_raw);
                                                                  }}
                                                                  icon={"raw_on"}
                                                                  title={device?.recent_alarm_input_raw}/>
                                                    <MaterialIcon className={"material-icons as-btn-2x"}
                                                                  onClick={() => {
                                                                      toast.info(device?.recent_alarm_input_parsed);
                                                                      navigator?.clipboard?.writeText(device?.recent_alarm_input_parsed);
                                                                  }}
                                                                  icon={"data_object"}
                                                                  title={device?.recent_alarm_input_parsed}/>
                                                </td>
                                                <td className={"text-center"}>{device?.modify_time}</td>
                                            </tr>);
                                        } else {
                                            return <tr title={"Impersonate this campus for server linking."}>
                                                <td>{device?.description}</td>
                                                <td className={"text-center"}>{device?.count_process_queue}</td>
                                                <td className={"text-center"}>{device?.count_aggregate_repeater_queue}</td>
                                                <td className={"text-center"}>{device?.count_eman_event_queue}</td>
                                                <td className={"text-center"}>{device?.count_maint_queue}</td>
                                                <td className={"text-center"}>{device?.count_other_queue}</td>
                                                <td className={"text-center"}>{device?.recent_alarm_input_time}</td>
                                                <td className={"text-center"}>
                                                    <MaterialIcon className={"material-icons as-btn-2x me-2"}
                                                                  onClick={() => toast.info(device?.recent_alarm_input_raw)}
                                                                  icon={"raw_on"}
                                                                  title={device?.recent_alarm_input_raw}/>
                                                    <MaterialIcon className={"material-icons as-btn-2x"}
                                                                  onClick={() => toast.info(device?.recent_alarm_input_parsed)}
                                                                  icon={"data_object"}
                                                                  title={device?.recent_alarm_input_parsed}/>
                                                </td>
                                                <td className={"text-center"}>{device?.modify_time}</td>
                                            </tr>
                                        }
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className={tabItem === "migrate" ? "d-block" : "d-none"}>
                        {groupActiveData.length === 0 && userActiveData.length === 0 && afrData.length === 0
                            ?   <div className={"ms-3"}>
                                    <p>No assets to migrate.</p>
                                </div>
                            :   <></>
                        }
                        {groupActiveData.length > 0
                            ? <>
                                <div className={"card"} style={{minWidth: "500px"}}>
                                    <div className={"card-header d-flex justify-content-between"}>
                                        <div>
                                            <h3 className={"card-header-title d-inline-block"}
                                                style={{minWidth: "80px"}}>2.0 Groups</h3>
                                            <div className={"d-inline"} style={{display: "inline-block"}}
                                                 id={"group-header-data"}>
                                                <h3 className={"ms-6 my-0 d-inline-block text-success"}>{groupActiveData?.length} Groups
                                                    available to migrate</h3>
                                            </div>
                                        </div>
                                        <div>
                                            <i className={"fe fe-plus as-btn collapse-toggle p-2"} id={"group-card-btn"}
                                               onClick={() => {
                                                   toggleCollapse("group-card-btn", "group-card");
                                                   document.getElementById("group-header-data").classList.toggle("d-none");
                                               }}></i>
                                        </div>
                                    </div>
                                    <div className={"card-body collapse collapse-content hide"} id={"group-card"}
                                         style={{maxHeight: "500px", overflowY: "auto"}}>
                                        <div className={"d-flex justify-content-between"}>
                                            <div>

                                            </div>
                                            <div style={{minHeight: "55px"}}>
                                                {addRights
                                                    ?   <Button text={"Migrate"} type={"button"}
                                                              class={"btn btn-primary me-2 hide mb-3"}
                                                              id={"migrateGroupBtn"} icon={true}
                                                              iconClass={"fe fe-upload-cloud me-2"}
                                                              onClick={() => confirmModalHandler({
                                                                  start_index: groupPPRules.start,
                                                                  end_index: groupPPRules.end,
                                                                  table_data: groupActiveData,
                                                                  display_item: "GroupName",
                                                                  record_item: ["GroupId", ""],
                                                                  content_setter: setDContent2,
                                                                  checkbox_id: "uCheckGroup",
                                                                  body_text: "The following groups will be migrated to 4.0. This cannot be undone, do you wish to proceed?",
                                                                  stored_content: "uContent2",
                                                                  rights: addRights,
                                                                  title: "Group Confirmation",
                                                                  submit_func: migrateGroupPerformSubmit
                                                              })}/>
                                                    :   <></>
                                                }
                                            </div>
                                        </div>
                                        <div>
                                            <table className={"table table-sm table-white table-hover"}>
                                                <thead className={"sticky-table-head"} style={{top: "-25px"}}>
                                                {groupHeaders}
                                                </thead>
                                                <tbody>
                                                {groupRows}
                                                </tbody>
                                            </table>
                                            <div className={"text-center"}>
                                                <Pagination>
                                                    <PaginationItems setPage={setGroupPage} page={groupPage}
                                                                     beginDot={groupPPRules.beginDot}
                                                                     endDot={groupPPRules.endDot}
                                                                     pageMin={groupPPRules.pageMin}
                                                                     pageMax={groupPPRules.pageMax}
                                                                     max={groupPPRules.max}/>
                                                </Pagination>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                            : <></>}
                        {userActiveData.length > 0
                            ? <>
                                <div className={"card"} style={{minWidth: "500px"}}>
                                    <div className={"card-header d-flex justify-content-between"}>
                                        <div>
                                            <h3 className={"card-header-title d-inline-block"}
                                                style={{minWidth: "80px"}}>2.0 Users</h3>
                                            <div className={"d-inline"} style={{display: "inline-block"}}
                                                 id={"user-header-data"}>
                                                <h3 className={"ms-6 my-0 d-inline-block text-success"}>
                                                    {userActiveData?.length} Users available to migrate
                                                </h3>
                                            </div>
                                        </div>
                                        <div>
                                            <i className={"fe fe-plus as-btn collapse-toggle p-2"} id={"user-card-btn"}
                                               onClick={() => {
                                                   toggleCollapse("user-card-btn", "user-card");
                                                   document.getElementById("user-header-data").classList.toggle("d-none");
                                               }}></i>
                                        </div>
                                    </div>
                                    <div className={"card-body collapse collapse-content hide"} id={"user-card"}
                                         style={{maxHeight: "500px", overflowY: "auto"}}>
                                        <div className={"d-flex justify-content-between"}>
                                            <div>

                                            </div>
                                            <div style={{minHeight: "55px"}}>
                                                {addRights
                                                    ?   <Button text={"Migrate"} type={"button"}
                                                              class={"btn btn-primary me-2 hide mb-3"}
                                                              id={"migrateBtn"} icon={true}
                                                              iconClass={"fe fe-upload-cloud me-2"}
                                                              onClick={() => confirmModalHandler({
                                                                  start_index: ppRules.start,
                                                                  end_index: ppRules.end,
                                                                  table_data: userActiveData,
                                                                  display_item: "UserName",
                                                                  record_item: ["UserId", ""],
                                                                  content_setter: setDContent,
                                                                  checkbox_id: "uCheckUser",
                                                                  body_text: "The following users will be migrated to 4.0. This cannot be undone, do you wish to proceed?",
                                                                  stored_content: "uContent",
                                                                  rights: addRights,
                                                                  title: "User Confirmation",
                                                                  submit_func: migratePerformSubmit
                                                              })}/>
                                                    :   <></>
                                                }
                                            </div>
                                        </div>
                                        <div>
                                            <table className={"table table-sm table-white table-hover"}>
                                                <thead className={"sticky-table-head"} style={{top: "-25px"}}>
                                                {userHeaders}
                                                </thead>
                                                <tbody>
                                                {userRows}
                                                </tbody>
                                            </table>
                                            <div className={"text-center"}>
                                                <Pagination>
                                                    <PaginationItems setPage={setPage} page={page}
                                                                     beginDot={ppRules.beginDot}
                                                                     endDot={ppRules.endDot} pageMin={ppRules.pageMin}
                                                                     pageMax={ppRules.pageMax}
                                                                     max={ppRules.max}/>
                                                </Pagination>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                            : <></>}
                        {afrDataSet.length > 0
                            ? <>
                                <div className={"card"} style={{minWidth: "500px"}}>
                                    <div className={"card-header d-flex justify-content-between"}>
                                        <div>
                                            <h3 className={"card-header-title d-inline-block"}
                                                style={{minWidth: "80px"}}>2.0 AFR Devices</h3>
                                            <div className={"d-inline"} style={{display: "inline-block"}}
                                                 id={"afr-header-data"}>
                                                <h3 className={"ms-6 my-0 d-inline-block text-success"}>
                                                    {afrDataSet?.length} Devices available to migrate
                                                </h3>
                                            </div>
                                        </div>
                                        <div>
                                            <i className={"fe fe-plus as-btn collapse-toggle p-2"} id={"afr-card-btn"}
                                               onClick={() => {
                                                   toggleCollapse("afr-card-btn", "afr-card");
                                                   document.getElementById("afr-header-data").classList.toggle("d-none");
                                               }}></i>
                                        </div>
                                    </div>
                                    <div className={"card-body collapse collapse-content hide"} id={"afr-card"}
                                         style={{maxHeight: "500px", overflowY: "auto"}}>
                                        <div className={"d-flex justify-content-between"}>
                                            <div>

                                            </div>
                                            <div style={{minHeight: "55px"}}>
                                                {addRights
                                                    ?   <Button text={"Migrate"} type={"button"}
                                                              class={"btn btn-primary me-2 hide mb-3"}
                                                              id={"migrateAFRBtn"} icon={true}
                                                              iconClass={"fe fe-upload-cloud me-2"}
                                                              onClick={() => confirmModalHandler({
                                                                  start_index: 0,
                                                                  end_index: afrDataSet.length,
                                                                  table_data: afrDataSet,
                                                                  display_item: "device_type_name",
                                                                  record_item: ["device_type_id", ""],
                                                                  content_setter: setDContent3,
                                                                  checkbox_id: "uCheckAFR",
                                                                  body_text: "The following device types for Accept Finish Reasons will be migrated to 4.0. This cannot be undone, do you wish to proceed?",
                                                                  stored_content: "uContent3",
                                                                  rights: addRights,
                                                                  title: "AFR Device Confirmation",
                                                                  submit_func: migrateAFRPerformSubmit
                                                              })}/>
                                                    :   <></>
                                                }
                                            </div>
                                        </div>
                                        <div>
                                            <table className={"table table-sm table-white table-hover"}>
                                                <thead className={"sticky-table-head"} style={{top: "-25px"}}>
                                                {afrHeaders}
                                                </thead>
                                                <tbody>
                                                {afrRows}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </>
                            : <></>
                        }
                        {hpDataSet.length > 0
                            ? <>
                                <div className={"card"} style={{minWidth: "500px"}}>
                                    <div className={"card-header d-flex justify-content-between"}>
                                        <div>
                                            <h3 className={"card-header-title d-inline-block"}
                                                style={{minWidth: "80px"}}>2.0 High Priority Alerts</h3>
                                            <div className={"d-inline"} style={{display: "inline-block"}}
                                                 id={"hp-header-data"}>
                                                <h3 className={"ms-6 my-0 d-inline-block text-success"}>
                                                    {hpDataSet?.length} Alert types available to migrate
                                                </h3>
                                            </div>
                                        </div>
                                        <div>
                                            <i className={"fe fe-plus as-btn collapse-toggle p-2"} id={"hp-card-btn"}
                                               onClick={() => {
                                                   toggleCollapse("hp-card-btn", "hp-card");
                                                   document.getElementById("hp-header-data").classList.toggle("d-none");
                                               }}></i>
                                        </div>
                                    </div>
                                    <div className={"card-body collapse collapse-content hide"} id={"hp-card"}
                                         style={{maxHeight: "500px", overflowY: "auto"}}>
                                        <div className={"d-flex justify-content-between"}>
                                            <div>

                                            </div>
                                            <div style={{minHeight: "55px"}}>
                                                {addRights
                                                    ?   <Button text={"Migrate"} type={"button"}
                                                              class={"btn btn-primary me-2 hide mb-3"}
                                                              id={"migrateHPBtn"} icon={true}
                                                              iconClass={"fe fe-upload-cloud me-2"}
                                                              onClick={() => confirmModalHandler({
                                                                  start_index: 0,
                                                                  end_index: hpDataSet.length,
                                                                  table_data: hpDataSet,
                                                                  display_item: "event_type_name",
                                                                  record_item: ["event_type_id", ""],
                                                                  content_setter: setDContent4,
                                                                  checkbox_id: "uCheckHP",
                                                                  body_text: "The following high priority event types will be migrated to 4.0. This cannot be undone, do you wish to proceed?",
                                                                  stored_content: "uContent4",
                                                                  rights: addRights,
                                                                  title: "High Priority Alert Confirmation",
                                                                  submit_func: migrateHPPerformSubmit
                                                              })}/>
                                                    :   <></>
                                                }
                                            </div>
                                        </div>
                                        <div>
                                            <table className={"table table-sm table-white table-hover"}>
                                                <thead className={"sticky-table-head"} style={{top: "-25px"}}>
                                                {hpHeaders}
                                                </thead>
                                                <tbody>
                                                {hpRows}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </>
                            : <></>
                        }
                        {reasonDataSet.length > 0
                            ? <>
                                <div className={"card"} style={{minWidth: "500px"}}>
                                    <div className={"card-header d-flex justify-content-between"}>
                                        <div>
                                            <h3 className={"card-header-title d-inline-block"}
                                                style={{minWidth: "80px"}}>2.0 Custom Reason Codes</h3>
                                            <div className={"d-inline"} style={{display: "inline-block"}}
                                                 id={"reason-header-data"}>
                                                <h3 className={"ms-6 my-0 d-inline-block text-success"}>
                                                    {reasonDataSet?.length} Reason codes available to migrate
                                                </h3>
                                            </div>
                                        </div>
                                        <div>
                                            <i className={"fe fe-plus as-btn collapse-toggle p-2"}
                                               id={"reason-card-btn"}
                                               onClick={() => {
                                                   toggleCollapse("reason-card-btn", "reason-card");
                                                   document.getElementById("reason-header-data").classList.toggle("d-none");
                                               }}></i>
                                        </div>
                                    </div>
                                    <div className={"card-body collapse collapse-content hide"} id={"reason-card"}
                                         style={{maxHeight: "500px", overflowY: "auto"}}>
                                        <div className={"d-flex justify-content-between"}>
                                            <div>

                                            </div>
                                            <div style={{minHeight: "55px"}}>
                                                {addRights
                                                    ?   <Button text={"Migrate"} type={"button"}
                                                              class={"btn btn-primary me-2 hide mb-3"}
                                                              id={"migrateReasonBtn"} icon={true}
                                                              iconClass={"fe fe-upload-cloud me-2"}
                                                              onClick={() => confirmModalHandler({
                                                                  start_index: 0,
                                                                  end_index: reasonDataSet.length,
                                                                  table_data: reasonDataSet,
                                                                  display_item: "reason_code_description",
                                                                  record_item: ["reason_code_id", ""],
                                                                  content_setter: setDContent5,
                                                                  checkbox_id: "uCheckReason",
                                                                  body_text: "The following reason codes will be migrated to 4.0. This cannot be undone, do you wish to proceed?",
                                                                  stored_content_id: "uContent5",
                                                                  rights: addRights,
                                                                  title: "Reason Code Confirmation",
                                                                  submit_func: migrateReasonPerformSubmit
                                                              })}/>
                                                    :   <></>
                                                }
                                            </div>
                                        </div>
                                        <div>
                                            <table className={"table table-sm table-white table-hover"}>
                                                <thead className={"sticky-table-head"} style={{top: "-25px"}}>
                                                {reasonHeaders}
                                                </thead>
                                                <tbody>
                                                {reasonRows}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </>
                            : <></>
                        }
                        {alertData.length > 0 && myAlertData.length === 0
                            ? <>
                                <div className={"card"} style={{minWidth: "500px"}}>
                                    <div className={"card-header d-flex justify-content-between"}>
                                        <div>
                                            <h3 className={"card-header-title d-inline-block"}
                                                style={{minWidth: "80px"}}>2.0 Alert Settings</h3>
                                            <div className={"d-inline"} style={{display: "inline-block"}}
                                                 id={"alert-header-data"}>
                                                <h3 className={"ms-6 my-0 d-inline-block text-success"}>
                                                    2.0 Alert & Customization settings available to migrate
                                                </h3>
                                            </div>
                                        </div>
                                        <div>
                                            <i className={"fe fe-plus as-btn collapse-toggle p-2"}
                                               id={"alert-card-btn"}
                                               onClick={() => {
                                                   toggleCollapse("alert-card-btn", "alert-card");
                                                   document.getElementById("alert-header-data").classList.toggle("d-none");
                                               }}></i>
                                        </div>
                                    </div>
                                    <div className={"card-body collapse collapse-content hide"} id={"alert-card"}
                                         style={{maxHeight: "500px", overflowY: "auto"}}>
                                        <div className={"d-flex justify-content-between"}>
                                            <div>

                                            </div>
                                            <div style={{minHeight: "55px"}}>
                                                {addRights
                                                    ?   <Button text={"Migrate"} type={"button"}
                                                              class={"btn btn-primary me-2 show mb-3"}
                                                              id={"migrateAlertBtn"} icon={true}
                                                              iconClass={"fe fe-upload-cloud me-2"}
                                                              onClick={() => confirmModalHandler({
                                                                  title: "Alert Settings Confirmation",
                                                                  rights: addRights,
                                                                  body_text: "Are you sure you wish to migrate alert and customization settings from 2.0. This will overwrite any current settings for the campus.",
                                                                  submit_func: migrateAlertPerformSubmit
                                                              })}/>
                                                    :   <></>
                                                }
                                            </div>
                                        </div>
                                        <div>
                                            <ul style={{listStyle: "none"}}>
                                                {alertData.map((a, i) => {
                                                    return (
                                                        <>
                                                            <li key={`accept-${i}`}>Accept: <span
                                                                className={"fw-bold"}>{a.AcceptButtonEnabled.toString().toUpperCase()}</span>
                                                            </li>
                                                            <li key={`finish-${i}`}>Finish: <span
                                                                className={"fw-bold"}>{a.FinishButtonEnabled.toString().toUpperCase()}</span>
                                                            </li>
                                                            <li key={`reason-${i}`}>Reason: <span
                                                                className={"fw-bold"}>{a.ReasonCodeEnabled.toString().toUpperCase()}</span>
                                                            </li>
                                                            <li key={`accept-time-${i}`}>Release: After <span
                                                                className={"fw-bold"}>{a.ReleaseTimeInterval}</span> Minutes
                                                            </li>
                                                            <li key={`clear-time-${i}`}>Clear: After <span
                                                                className={"fw-bold"}>{a.ClearTimeInterval}</span> Minutes
                                                            </li>
                                                            <li key={`finish-time-${i}`}>Finish: After <span
                                                                className={"fw-bold"}>{a.FinishTimeInterval}</span> Minutes
                                                            </li>
                                                            <li key={`group-${i}`}>Group Edit: <span
                                                                className={"fw-bold"}>{a.CaregiverChgGroupEnabled.toString().toUpperCase()}</span>
                                                            </li>
                                                            <li key={`display-${i}`}>Display Edit: <span
                                                                className={"fw-bold"}>{a.UserEditDisplayName.toString().toUpperCase()}</span>
                                                            </li>
                                                        </>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </>
                            : <></>
                        }
                    </div>
                    <div className={tabItem === "geofence" ? "d-block" : "d-none"}>
                        <div className={"card"}>
                            {/*<div className={"card-header d-flex justify-content-between"}>*/}
                            {/*    <div>*/}
                            {/*        <h3 className={"card-header-title d-inline-block"}>Geofencing</h3>*/}
                            {/*    </div>*/}
                            {/*    <div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className={"card-body collapse collapse-content show"} id={"notes-card"}>
                                <div className={"d-flex justify-content-between pb-3"}>
                                    <div>

                                    </div>
                                    <div>
                                    </div>
                                </div>
                                <div style={{height: "650px"}}>
                                    {mapCont}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id={"designer-tab-item"} className={"d-block w-100 h-100"}>
                        {geofenceMap}
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"uploadmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={"-1"} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Upload Master File CSV</h2>
                            <button type={"button"} className={"btn-close"} id={"uploadConfirmClose"}
                                    data-bs-dismiss={"modal"} aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <div className={"d-inline-block align-bottom"}>
                                <input className={"d-none"} id={"file-upload"} type={"file"} accept={".csv"}
                                       onChange={() => handleFileUpload()}/>
                                <Button type={"button"} text={"Set File"}
                                        class={"btn btn-outline-primary me-4 d-inline"}
                                        onClick={() => {
                                            document.getElementById("file-upload").click();
                                        }}/>
                                <div className={"form-floating mb-3 d-inline-block"} style={{width: "250px"}}>
                                    <input type={"text"} id={"filename-item"} className={"form-control"}
                                           readOnly={true} value={newFileName}></input>
                                    <label htmlFor={"filename-item"}>Selected File</label>
                                </div>
                            </div>
                        </div>
                        <div className={"modal-footer d-flex justify-content-between"}>
                            <div>
                                <Button type={"button"} class={"btn btn-primary"} text={"Check File"}
                                        onClick={() => uploadPrecheck()}
                                        disabled={newFile === ""}/>
                            </div>
                            <div>
                                <button type={"button"} className={"btn btn-secondary mx-2"} style={{width: "75px"}}
                                        data-bs-dismiss={"modal"} id={"uploadCancel"}>Cancel
                                </button>
                                <Button type={"button"} class={"btn btn-primary d-none ms-2"} style={{width: "100px"}}
                                        disabled={true} spinner={true} text={"Uploading"} id={"loadUploadSubmit"}/>
                                <button type={"button"}
                                        className={newFile === "" || !fileValid ? "btn btn-danger ms-2" : "btn btn-primary ms-2"}
                                        style={{width: "100px"}} id={"uploadSubmit"}
                                        disabled={newFile === "" || !fileValid}
                                        onClick={() => uploadSubmit()}>Upload
                                </button>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"onboardmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={"-1"} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Upload Onboarding Excel</h2>
                            <button type={"button"} className={"btn-close"} id={"onboardUploadConfirmClose"}
                                    data-bs-dismiss={"modal"} aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <div className={"d-inline-block align-bottom"}>
                                <input className={"d-none"} id={"onboard-file-upload"} type={"file"} accept={".xlsx"}
                                       onChange={() => handleOnboardFileUpload()}/>
                                <Button type={"button"} text={"Set File"}
                                        class={"btn btn-outline-primary me-4 d-inline"}
                                        onClick={() => {
                                            document.getElementById("onboard-file-upload").click();
                                        }}/>
                                <div className={"form-floating mb-3 d-inline-block"} style={{width: "250px"}}>
                                    <input type={"text"} id={"onboard-filename-item"} className={"form-control"}
                                           readOnly={true} value={newOnboardUploadFileName}></input>
                                    <label htmlFor={"onboard-filename-item"}>Selected File</label>
                                </div>
                            </div>
                        </div>
                        <div className={"modal-footer d-flex justify-content-between"}>
                            <div>
                            </div>
                            <div>
                                <button type={"button"} className={"btn btn-secondary mx-2"} style={{width: "75px"}}
                                        data-bs-dismiss={"modal"} id={"uploadOnboardCancel"}
                                        onClick={() => {
                                            setOnboardFile(null);
                                            setNewOnboardFileName(""); document.getElementById("onboard-file-upload").value = ""; }}>
                                    Cancel
                                </button>
                                <Button type={"button"} class={"btn btn-primary d-none ms-2"} style={{width: "100px"}}
                                        disabled={true} spinner={true} text={"Uploading"} id={"loadUploadOnboardSubmit"}/>
                                <button type={"button"}
                                        className={newOnboardUploadFileName === "" ? "btn btn-danger ms-2" : "btn btn-primary ms-2"}
                                        style={{width: "100px"}} id={"uploadOnboardSubmit"}
                                        disabled={newOnboardUploadFileName === ""}
                                        onClick={() => onboardFileUploadSubmit()}>Upload
                                </button>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"addnotemodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticAddNoteBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title text-capitalize"} id={"staticAddNoteBackdropLabel"}>
                                Add Note
                            </h2>
                            <button type={"button"} className={"btn-close"} id={"addNoteClose"}
                                    data-bs-dismiss={"modal"} aria-label={"Close"}/>
                        </div>
                        <form id={"addNoteForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <div className={"my-2 form-floating"}>
                                    <textarea className={"form-control pt-5"} id={"note"} required={true}
                                              onKeyUp={() => formCheck("addNoteForm", "addNoteSubmit")}>

                                    </textarea>
                                    <label htmlFor={"note"} className={"form-label"}>Note</label>
                                    <div className={"invalid-feedback"}>
                                        Note required
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <div>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelAddNoteBtn"}
                                            data-bs-dismiss={"modal"}>Cancel
                                    </button>
                                    <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                            spinner={true} text={"Loading"} id={"loadAddNoteSubmit"}/>
                                    <button type={"button"} className={"btn btn-primary ms-3"} id={"addNoteSubmit"}
                                            onClick={() => addNoteSubmit()}>Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"editnotemodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticEditNoteConfirmLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticEditNoteConfirmLabel"}>Edit Note</h2>
                            <button type={"button"} className={"btn-close"} id={"editNoteConfirmClose"}
                                    data-bs-dismiss={"modal"} aria-label={"Close"}/>
                        </div>
                        <form id={"editNoteForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <div className={"my-2 form-floating"}>
                                    <textarea className={"form-control pt-5"} id={"noteE"} required={true}>

                                    </textarea>
                                    <label htmlFor={"noteE"} className={"form-label"}>Note</label>
                                    <div className={"invalid-feedback"}>
                                        Note required
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <button type={"button"} className={"btn btn-secondary"} id={"cancelEditNoteBtn"}
                                        data-bs-dismiss={"modal"}>Cancel
                                </button>
                                <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                        spinner={true}
                                        text={"Loading"} id={"loadEditNoteSubmit"}/>
                                <button type={"button"} className={"btn btn-primary ms-3"}
                                        onClick={() => editNoteSubmit()}
                                        id={"editNoteSubmit"}>Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"impersonatemodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Role to impersonate as?</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <form id={"impersonateForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <div className={"form-floating"}>
                                    <select className={"form-select"} required={true} id={"userrole"}
                                            onChange={(e) => {
                                                formCheck("impersonateForm", "impersonateSubmit");
                                            }}>
                                        <option value={dData.my_role_weight}>My Role</option>
                                        {roleOptions}
                                    </select>
                                    <label htmlFor={"userrole"}>Impersonating User Role</label>
                                </div>
                            </div>
                            <div className={"modal-footer"}>
                                <button type={"button"} className={"btn btn-secondary"} id={"cancelImpersonateBtn"}
                                        data-bs-dismiss={"modal"}>Cancel
                                </button>
                                <Button type={"button"} class={"btn btn-primary d-none"} disabled={true}
                                        spinner={true}
                                        text={"Loading"} id={"loadImpersonateSubmit"}/>
                                <button type={"button"} className={"btn btn-primary"} id={"impersonateSubmit"}
                                        onClick={() => {
                                            let rweight;
                                            handleSubmitActions("impersonateSubmit", "loadImpersonateSubmit");
                                            rweight = document.getElementById("userrole").value;
                                            setRoleInfo(parseInt(rweight), dData);
                                            reloadSessionCorp(corporateId, 0, dData.cognito, dData, campusId);
                                        }}>Impersonate
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"integrationmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Configure Integration</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <form id={"integrationForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                <div className={"form-floating mb-3"} id={"int-com-id-div"}>
                                    <input type={"text"} className={"form-control"} id={"int-com-id"}
                                           onKeyUp={() => formCheck("integrationForm", "integrationSubmit")}
                                           required={true} pattern={"^[ -~]+$"}/>
                                    <label htmlFor={"int-com-id"}>External Community ID</label>
                                    <div className={"invalid-feedback"}>
                                        Please enter the community id from integrated company
                                    </div>
                                </div>
                                <div className={"form-floating mb-3"} id={"int-credential-div"}>
                                    <input type={"text"} className={"form-control"} id={"int-credential"}
                                           onKeyUp={() => formCheck("integrationForm", "integrationSubmit")}
                                           required={true} pattern={"^[ -~]+$"}/>
                                    <label htmlFor={"int-credential"}>Credentials</label>
                                    <div className={"invalid-feedback"}>
                                        Please enter username or identifying credential
                                    </div>
                                </div>
                                <div className={"form-floating mb-3"} id={"int-auth-div"}>
                                    <input type={"text"} className={"form-control"} id={"int-auth"}
                                           onKeyUp={() => formCheck("integrationForm", "integrationSubmit")}
                                           required={true} pattern={"^[ -~]+$"}/>
                                    <label htmlFor={"int-auth"}>Auth Token</label>
                                    <div className={"invalid-feedback"}>
                                        Please enter password or defined token for authentication
                                    </div>
                                </div>
                                <div className={"list-group"}>
                                    <div className={"list-group-item"} id={"int-receiving-div"}>
                                        <div className={"form-check form-switch"}>
                                            <input className={"form-check-input"} type={"checkbox"}
                                                   id={"int-receiving"} defaultChecked={false} />
                                            <label className={"form-check-label text-dark"}
                                                   htmlFor={"int-receiving"}>
                                                Receiving Data
                                            </label>
                                        </div>
                                    </div>
                                    <div className={"list-group-item"} id={"int-sending-div"}>
                                        <div className={"form-check form-switch"}>
                                            <input className={"form-check-input"} type={"checkbox"}
                                                   id={"int-sending"} defaultChecked={false} />
                                            <label className={"form-check-label text-dark"}
                                                   htmlFor={"int-sending"}>
                                                Sending Data
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={"modal-footer justify-content-between"}>
                                <div>
                                    <Button text={"Delete"} icon={true} iconClass={"fe fe-trash-2 me-2"} type={"button"}
                                            class={"btn btn-danger"} id={"integrationDeleteSubmit"}
                                            onClick={() => {
                                                swapModal("cancelIntegrationBtn", "confirmintdelete");
                                            }} />
                                </div>
                                <div>
                                    <button type={"button"} className={"btn btn-secondary me-3"} id={"cancelIntegrationBtn"}
                                            data-bs-dismiss={"modal"}>Cancel
                                    </button>
                                    <Button type={"button"} class={"btn btn-primary d-none"} disabled={true}
                                            spinner={true}
                                            text={"Loading"} id={"loadIntegrationSubmit"}/>
                                    <button type={"button"} className={"btn btn-primary"} id={"integrationSubmit"}
                                            onClick={() => {
                                                if (outputOp === "Edit"){
                                                    editIntegrationSubmit();
                                                }else{
                                                    addIntegrationSubmit();
                                                }
                                            }}>Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"confirmdeactivate"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Stop Integration?</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <h4>Are you sure you wish to de-activate this integration? Re-activation may require new
                                onboarding to ensure data is properly synced.
                            </h4>
                        </div>
                        <div className={"modal-footer"}>
                            <button type={"button"} className={"btn btn-secondary"} id={"cancelDisableIntBtn"}
                                    data-bs-dismiss={"modal"}>No
                            </button>
                            <Button type={"button"} class={"btn btn-primary d-none"} disabled={true}
                                    spinner={true} text={"Disabling"} id={"loadDisableIntSubmit"}/>
                            <button type={"button"} className={"btn btn-primary"} id={"disableIntSubmit"}
                                    onClick={() => {disableIntegration()}}>Yes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"confirmintdelete"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Remove Integration?</h2>
                            <button type={"button"} className={"btn-close"} id={"deleteIntConfirmClose"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <h4>Are you sure you wish to delete the integration settings?</h4>
                        </div>
                        <div className={"modal-footer"}>
                            <button type={"button"} className={"btn btn-secondary"} id={"cancelDeleteIntBtn"}
                                    data-bs-dismiss={"modal"}
                                    onClick={() => {
                                        swapModal("deleteIntConfirmClose", "integrationmodal")
                                    }}>No
                            </button>
                            <Button type={"button"} class={"btn btn-primary d-none"} disabled={true}
                                    spinner={true} text={"Disabling"} id={"loadDeleteIntSubmit"}/>
                            <button type={"button"} className={"btn btn-primary"} id={"deleteIntSubmit"}
                                    onClick={() => {integrationDeletePerform()}}>Yes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"confirmactivate"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticBackdropLabel"}>Start Integration?</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <h4>
                                Are you sure you wish to activate this integration to Live Status?
                            </h4>
                        </div>
                        <div className={"modal-footer"}>
                            <button type={"button"} className={"btn btn-secondary"} id={"cancelEnableIntBtn"}
                                    data-bs-dismiss={"modal"}>No
                            </button>
                            <Button type={"button"} class={"btn btn-primary d-none"} disabled={true}
                                    spinner={true} text={"Disabling"} id={"loadEnableIntSubmit"}/>
                            <button type={"button"} className={"btn btn-primary"} id={"enableIntSubmit"}
                                    onClick={() => {enableIntegration()}}>Yes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <ConfirmModal/>
            <input type={"hidden"} id={"dContent"}/>
            <input type={"hidden"} id={"dContent2"}/>
            <input type={"hidden"} id={"uContent"}/>
            <input type={"hidden"} id={"uContent2"}/>
            <input type={"hidden"} id={"uContent3"}/>
            <input type={"hidden"} id={"uContent4"}/>
            <input type={"hidden"} id={"uContent5"}/>
            <BulkDeleteModal
                modalName={"deletenotesmodal"}
                deletePerform={() => deleteNotesPerform("bulkDeleteSubmit", "loadBulkDeleteSubmit", "bulkConfirmClose", notesPPRules.start, notesPPRules.end)}
                start={notesPPRules.start} end={notesPPRules.end} header={"Delete Notes"}/>
            <button
                type={"button"}
                className={"help-corner-button"}
                onClick={() => showModal("helpmodal")}
                title={"Page Help Popup"}
                aria-label={"Open Help"}
            >
                <i className={"fe fe-help-circle help-corner-button-icon"}></i>
            </button>
            <div className={"modal fade help-modal-pop"} id={"helpmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticHelpBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog modal-lg"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticHelpBackdropLabel"}>Campus Profile Page Help</h2>
                            <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <div className={"mb-4"}>
                                <h4 className={"text-primary mb-3"}>
                                    <i className={"fe fe-info me-2"}></i>Getting Started
                                </h4>
                                <p className={"mb-2"}>
                                    This page provides detailed information and configuration options for a specific campus, including basic information, settings, integrations, notes, and server information.
                                </p>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-layers me-2 text-primary"}></i>Page Tabs
                                </h5>
                                <p className={"mb-2"}>The page is organized into several tabs:</p>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}><strong>Basic Info</strong>: View and edit campus details such as name, address, contact information, timezone, and service plan</li>
                                    <li className={"mb-2"}><strong>Settings</strong>: Configure platform settings, reporting options, output features, and careflow settings</li>
                                    <li className={"mb-2"}><strong>Integrations</strong>: Manage third-party integrations such as EHR systems, pagers, and other external services</li>
                                    <li className={"mb-2"}><strong>Notes</strong>: View and manage campus notes with timestamps and creator information</li>
                                    <li className={"mb-2"}><strong>Server Info</strong>: View server device information and system status</li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-info me-2 text-primary"}></i>Basic Info Tab
                                </h5>
                                <p className={"mb-2"}>This tab displays the campus's basic information:</p>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}><strong>Campus Name</strong>: The name of the campus (editable with proper permissions)</li>
                                    <li className={"mb-2"}><strong>Address</strong>: Street address, city, state, zip code, and country (editable)</li>
                                    <li className={"mb-2"}><strong>Contact Information</strong>: Email and phone number (editable)</li>
                                    <li className={"mb-2"}><strong>Coordinates</strong>: Latitude and longitude for mapping (editable)</li>
                                    <li className={"mb-2"}><strong>Timezone</strong>: Timezone setting for the campus (editable)</li>
                                    <li className={"mb-2"}><strong>Service Plan</strong>: Current service plan information</li>
                                    <li className={"mb-2"}><strong>Corporation</strong>: The corporation this campus belongs to</li>
                                </ul>
                                <p className={"mb-2"}>Click the "Edit" button to modify campus information. Changes require appropriate permissions.</p>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-settings me-2 text-primary"}></i>Settings Tab
                                </h5>
                                <p className={"mb-2"}>This tab allows you to configure various campus settings:</p>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}><strong>Platform Settings</strong>: Configure cloud/hybrid architecture and platform features</li>
                                    <li className={"mb-2"}><strong>Reporting Settings</strong>: Configure event notes, reason editing, and reporting options</li>
                                    <li className={"mb-2"}><strong>Output Settings</strong>: Enable or disable output features like mobile, pager, text, voice, email, light controller, and offsite services</li>
                                    <li className={"mb-2"}><strong>Careflow Settings</strong>: Configure careflow-related settings and behaviors</li>
                                </ul>
                                <p className={"mb-2"}>Changes to settings may require appropriate permissions and may affect system behavior.</p>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-link me-2 text-primary"}></i>Integrations Tab
                                </h5>
                                <p className={"mb-2"}>This tab manages third-party integrations:</p>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>View all configured integrations for the campus</li>
                                    <li className={"mb-2"}>Add new integrations using the "Add Integration" button</li>
                                    <li className={"mb-2"}>Edit existing integration settings</li>
                                    <li className={"mb-2"}>Enable or disable integrations</li>
                                    <li className={"mb-2"}>Remove integrations that are no longer needed</li>
                                </ul>
                                <p className={"mb-2"}>Integrations allow the campus to connect with external systems like EHR platforms, pagers, and other services.</p>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-file-text me-2 text-primary"}></i>Notes Tab
                                </h5>
                                <p className={"mb-2"}>This tab displays campus notes:</p>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>View all notes associated with the campus</li>
                                    <li className={"mb-2"}>Add new notes using the "Add Note" button</li>
                                    <li className={"mb-2"}>Edit existing notes (with appropriate permissions)</li>
                                    <li className={"mb-2"}>Delete notes (with appropriate permissions)</li>
                                    <li className={"mb-2"}>Export notes to CSV format</li>
                                    <li className={"mb-2"}>Filter and search through notes</li>
                                </ul>
                                <p className={"mb-2"}>Notes are timestamped and show who created or modified them.</p>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-server me-2 text-primary"}></i>Server Info Tab
                                </h5>
                                <p className={"mb-2"}>This tab displays server-related information:</p>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>View server devices associated with the campus</li>
                                    <li className={"mb-2"}>Monitor server status and queue information</li>
                                    <li className={"mb-2"}>View device details and configurations</li>
                                </ul>
                            </div>

                            <div className={"mb-3"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-settings me-2 text-primary"}></i>Additional Tips
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>Use the collapse/expand icons on card headers to show or hide sections</li>
                                    <li className={"mb-2"}>Basic information refreshes every 10 minutes</li>
                                    <li className={"mb-2"}>Settings changes may take effect immediately or require a system refresh</li>
                                    <li className={"mb-2"}>Some settings may require higher authority permissions to modify</li>
                                    <li className={"mb-2"}>Integration changes should be tested carefully before enabling in production</li>
                                    <li className={"mb-2"}>Notes can be exported for record-keeping purposes</li>
                                </ul>
                            </div>
                        </div>
                        <div className={"modal-footer"}>
                            <button type={"button"} className={"btn btn-secondary"} data-bs-dismiss={"modal"}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
            <Suspense fallback={"Loading..."}>
                <ToastContainer position={"bottom-right"} theme={"colored"} newestOnTop={true} pauseOnHover={true}
                                autoClose={10000} closeOnClick={true}/>
            </Suspense>
        </>
    );
};

export default CampusProfile;